import React from "react";
import { Redirect } from "react-router";

import { Container, Grid, TextField, FormControlLabel, Checkbox, Button } from "@material-ui/core";
import ModalImage from "react-modal-image";
import Compressor from "compressorjs";
import { saveAs } from "file-saver";
import { useParams, useHistory } from "react-router-dom";
import { KeyboardDateTimePicker } from "@material-ui/pickers";
import Colors from "./../../Global/colors";
import DarkButton from "./../../Global/DarkButton";
import GlobalApi from "./../../Global";
import Spinner from "./../../Global/Spinner";
import { updateNotification } from "../../Redux/Actions/notificationAction";
import useDimensions from "./../../Global/useDimensions";
import swal from "@sweetalert/with-react";
import refresh_token from "./../../Global/refresh_token";
import { makeStyles } from "@material-ui/core/styles";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import Typography from "@material-ui/core/Typography";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import CircularProgress from '@material-ui/core/CircularProgress';

import moment from "moment";
import _ from "lodash";
import Paper from "@material-ui/core/Paper";
import DeleteIcon from "@material-ui/icons/Delete";

import noteIcon from "../../Assets/note.png";
import cameraIcon from "../../Assets/photos.png";
import videoIcon from "../../Assets/videos.png";
import actionIcon from "../../Assets/actionIcon.png";

import noteIconG from "../../Assets/noteG.png";
import cameraIconG from "../../Assets/photosG.png";
import videoIconG from "../../Assets/videosG.png";
import actionIconG from "../../Assets/actionIconG.png";
import { useTranslation } from "react-i18next";
import Slider from "@material-ui/core/Slider";
import InspectionAction from "./inspectionAction";
import ModalSpinner from "./../../Global/ProcessModal";
import { useSelector, useDispatch } from "react-redux";

var browser_name = "";
let isIE = /*@cc_on!@*/ false || !!document.documentMode;
let isEdge = !isIE && !!window.StyleMedia;
if (navigator.userAgent.indexOf("Chrome") != -1 && !isEdge) {
  browser_name = "chrome";
} else if (navigator.userAgent.indexOf("Safari") != -1 && !isEdge) {
  browser_name = "safari";
} else if (navigator.userAgent.indexOf("Firefox") != -1) {
  browser_name = "firefox";
} else if (
  navigator.userAgent.indexOf("MSIE") != -1 ||
  !!document.documentMode == true
) {
  //IF IE > 10
  browser_name = "ie";
} else if (isEdge) {
  browser_name = "edge";
} else {
  browser_name = "other-browser";
}
const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: "33.33%",
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: "#043077",
  },
}));
export default function InspectionEdit({ showside, hideside }) {
  let {t} = useTranslation();
  let language = useSelector((state) => state.languageReducer.language);
  let company = useSelector((state) => state.companyReducer.company);
  let { id, isReview } = useParams();
  let history = useHistory();
  let [currentUser, setCurrentUser] = React.useState({});
  const [btnLoader, setBtnLoader] = React.useState(false);

  let { width } = useDimensions();
  const [inspection, setInspection] = React.useState(null);
  const [template, setTemplate] = React.useState([]);
  const [answers, setAnswers] = React.useState({});
  const [hierarchyOrganization, setHierarchyOrganization] = React.useState({});
  const [comment, setComment] = React.useState("");
  const [user, setUser] = React.useState({});
  const [currentEditSection, setCurrentEditSection] = React.useState("");
  const [showSpinner, setSpinner] = React.useState(false);
  const [packageCurrentDetails, setPackageCurrentDetails] = React.useState({});
  const [selectedSection, setSelectedSection] = React.useState(0);
    const [totalScore, setTotalScore] = React.useState(0);
    const [totalActions, setTotalActions] = React.useState(0);
  const classes = useStyles();
  // const [expanded, setExpanded] = React.useState(false);

  console.log(
    "LKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKK",
    inspection
  );
  const dispatch = useDispatch();

  const [globalIndex, setGlobalIndex] = React.useState(0);
  let [packageDetails, setPackageDetails] = React.useState({});
  let [currentFileSize, setCurrentFileSize] = React.useState(0);
  let [requiredSections, setRequiredSections] = React.useState([]);

  console.log(
    "GLOBAL INDEX_______________________________________________________",
    globalIndex
  );
  // const Text = (panel) => (event, isExpanded) => {
  //   setExpanded(isExpanded ? panel : false);
  // };

  // console.log(inspection)

  React.useEffect(() => {
    console.log(browser_name, "{SAFARI}");
    getInspection();
    getUser();
    // hideside(false);
    if (isReview !== "edit" && isReview !== "view" ) {
      //alert(isReview)
      getHierarchyData();
      notificationRead();
    }
    getPackage();
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);

    setCurrentUser(data);
    getFileSize();
    console.log("+++++++++re reun");
    // return () => showside(true);
  }, []);



  async function getPackage() {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data?.token;
    let package_inquiry = {
      user_id: data.user_id,
      organization_id: data.organization_id,
    };

    let query = Object.keys(package_inquiry)
      .map(
        (k) =>
          encodeURIComponent(k) + "=" + encodeURIComponent(package_inquiry[k])
      )
      .join("&");


    let req = await fetch(
      GlobalApi + "/Package/get_user_license_details?" + query,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      }
    );
    let reqJson = await req.json();
    console.log("Calling Get License ", reqJson);

  
    if (reqJson?.package?.license?.status === "expired" || reqJson?.package?.license?.status === "deactive") {
      history.replace("/billing");
    } else {
      setPackageDetails(reqJson.package);
    }
  }

  function getFileSize() {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data?.token;
    let params = {
      user_id: data?.user_id,
      organization_id: data?.organization_id,
    };
    // console.log(data.user_id);
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/ConfigFileSize/get_all_file_sizes_user?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        if (response.status === "Success") {
          console.log(response.data);
          dispatch({ type: "SET_FILE_SIZE", payload: response.data });
          setCurrentFileSize(response.data);
          //setCurrentFileSize(102400)
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          let status = await refresh_token();
          if (status) {
            getPackage();
          }
        }
      })
      .catch((error) => console.log(error.message));
  }

  async function notificationRead() {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);

    let refrence = `inspection-edit/${id}/${isReview}`;

    // console.log(refrence, "REF STR")
    //  return
    let imageReq = await fetch(GlobalApi + "/Notification/edit_notification", {
      method: "Post",
      headers: new Headers({
        Authorization: "Bearer " + data.token,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify({
        user_id: data.user_id,
        refrence,
        is_read: true,
      }),
    });
    dispatch(updateNotification(company.id));
  }

  function getUser() {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);

    let token = data?.token;
    let params = {
      user_id: data?.user_id,
    };
    // console.log(data.user_id);
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/user/get_user?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        console.log(response);
        setUser(response.data);
      });
  }

  function getHierarchyData() {

    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data?.token;
    let params = {
      hierarchy_organization_id: isReview,
    };
    // console.log(data.user_id);
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(
      GlobalApi + "/HierarchyOrganization/get_hierarchy_organization?" + query,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      }
    )
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        setHierarchyOrganization(response.data);

        // alert(response.data)
      });
  }

  const getInspection = () => {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data?.token;
    let params = {
      inspection_id: id,
    };
    console.log(params);
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/Inspection/get_inspection?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        if (response.status === "Success") {
          
          if (response.data) {
            let sections_data = JSON.parse(response.data.section_score_arr);
            let finalScore = response.data.score;
     
            let action_count = 0;
            if (response.data.InspectionAnswers.length !== 0) {
              let answers_obj = {};
              // console.log(response.data.InspectionAnswers);
              response.data.InspectionAnswers.map(async (v, i) => {
                //alert(JSON.stringify(v.is_multiple))
                // console.log(v);
                let filterdActions = v.Actions.filter(item=>!item.isDeleted);
                answers_obj = {
                  ...answers_obj,
                  [v.check_id]: {
                    ...v,
                    Actions: filterdActions,
                    check_id: v.check_id,
                    value: v.value,
                    updated_by: data?.user_id,
                    inspection_answer_id: v.id,
                    image: v.image,
                    note: v.note,
                    ismultiple: v.is_multiple,
                    imageslist: v.multiple_images_arr_Urls
                      ? JSON.parse(v.multiple_images_arr_Urls)
                      : [],
                    imagelistsize: v.multiple_images_size,
                  },
                };

                answers_obj[v.check_id].Actions = filterdActions;
                action_count += filterdActions.length;
                //alert(JSON.stringify(answers_obj))
                // console.log("++++++", answers_obj[v.check_id])
                if (i === response.data.InspectionAnswers.length - 1) {
                  getTemplate(
                    response.data.template_id,
                    response.data,
                    response.data.InspectionAnswers,
                    answers_obj,
                    sections_data,
                    finalScore,
                  );
                }
              });
            } else {
              getTemplate(
                response.data.template_id,
                response.data,
                response.data.InspectionAnswers,
                {},
                sections_data,
                finalScore,
              );
            }
             console.log("inspection225",response.data);

            setInspection(response.data);
            // setTotalScore(response?.data?.score)
            setTotalActions(action_count);
            // console.log(response, "{}{}{}{}");
          }
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          let status = await refresh_token();
          console.log(status);
          if (status) {
            console.log("opopopop");
            getInspection();
          }
        }
      })
      .catch((error) => console.log(error.message));
    // console.log("op");
  };

  const getInspectionNew = (SectionInspections, InspectionAnswers) => {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    if (InspectionAnswers.length !== 0) {
      let answers_obj = {};
      // console.log(response.data.InspectionAnswers);
      
      InspectionAnswers.map(async (v, i) => {
        //alert(JSON.stringify(v.is_multiple))
        // console.log(v);
        let filterdActions = v.Actions.filter(item=>!item.isDeleted);
        answers_obj = {
          ...answers_obj,
          [v.check_id]: {
            ...v,
            Actions: filterdActions,
            check_id: v.check_id,
            value: v.value,
            updated_by: data?.user_id,
            inspection_answer_id: v.id,
            image: v.image,
            note: v.note,
            ismultiple: v.is_multiple,
            imageslist: v.multiple_images_arr_Urls
              ? JSON.parse(v.multiple_images_arr_Urls)
              : [],
            imagelistsize: v.multiple_images_size,
          },
        };

        answers_obj[v.check_id].Actions = filterdActions;
        if (i === InspectionAnswers.length - 1) {
          getTemplateNew(
            id,
            inspection,
            InspectionAnswers,
            answers_obj,
            SectionInspections
          );
        }
      });
    } else {
      getTemplateNew(id, inspection, InspectionAnswers, {}, SectionInspections);
    }
    getInspectionScore()
  };

  const getInspectionScore = () => {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data?.token;
    let params = {
      inspection_id: id,
    };
    console.log(params);
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/Inspection/get_inspection?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        if (response.status === "Success") {
         
          if (response.data) {
            let action_count = 0;
            if (response.data.InspectionAnswers.length !== 0) {
              let answers_obj = {};
             
              response.data.InspectionAnswers.map(async (v, i) => {
                let filterdActions = v.Actions.filter(item=>!item.isDeleted);
                answers_obj = {
                  ...answers_obj,
                  [v.check_id]: {
                    ...v,
                    Actions: filterdActions,
                    check_id: v.check_id,
                    value: v.value,
                    updated_by: data?.user_id,
                    inspection_answer_id: v.id,
                    image: v.image,
                    note: v.note,
                    ismultiple: v.is_multiple,
                    imageslist: v.multiple_images_arr_Urls
                      ? JSON.parse(v.multiple_images_arr_Urls)
                      : [],
                    imagelistsize: v.multiple_images_size,
                  },
                };

                answers_obj[v.check_id].Actions = filterdActions;
                action_count += filterdActions.length;

              });
            } 

            setTotalScore(response?.data?.score)
            setTotalActions(action_count);
          }
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          let status = await refresh_token();
          console.log(status);
          if (status) {
            console.log("opopopop");
            getInspectionScore();
          }
        }
      })
      .catch((error) => console.log(error.message));
    // console.log("op");
  };



  const getTemplateNew = async (
    id,
    inspection,
    inspection_answer,
    answers_obj_edit,
    SectionInspections
  ) => {
    var retrievedData = localStorage.getItem("UserData");
    var data = JSON.parse(retrievedData);

    var sections = [];

    let answers_obj = {};
    // =================================================================
    await SectionInspections.map((sec) => {
      var checklist = [];

      sec.CheckListInspections.map((item) => {
        console.log("Item", item);
        var responseList = [];
        var conditionalList = [];
        var subQuestionList = [];

        if (item.data_type === "Custom" || item.data_type === "Global") {
          item.ResponseSetInspections.map((r) => {
            var item = { id: r.id, title: r.title, position: r.position };
            responseList.push(item);
          });
          var responseLibrary = { id: item.id, responses: responseList };
        }

        if (item.is_conditional == "yes") {
          var list = sec.CheckListInspections.filter(
            (x) => x.parent_id == item.id  && x?.type !== "subquestion"
          );
          var responseListCQ = [];
          list.map((item) => {
            console.log(item);
            //alert(JSON.stringify(item.ResponseSets))
            if (item.data_type == "Custom" || item.data_type == "Global") {
              item.ResponseSetInspections.map((r) => {
                var responseItem = {
                  id: r.response_id,
                  title: r.title,
                  position: r.position,
                };
                responseListCQ.push(responseItem);
              });

              console.log("ResponseList ***********************", responseList);
              //alert(JSON.stringify(item.ResponseSets))
              var responseLibraryCQ = { id: item.id, responses:  responseListCQ.sort(
                (a, b) => a.position - b.position
              ), };
            }
            var conditionalItem = {
              id: item.id,
              title: item.title,
              dataType: item.data_type,
              position: item.position,
              status: "added",
              mandatory: item.is_mandatory,
              multiselection: item.is_multiple_allowed,
              condition: item.condition,
              conditionValue: item.condition_value,
              conditional: item.is_conditional,
              is_subquestion: item.is_subquestion,
              type: item.type,
              parent: item.parent_id,
              isopen: "no",
              // conditionalList: [],
              // subQuestionList: [],
              responseLibrary:
                item.data_type == "Custom" || item.data_type == "Global"
                  ? responseLibraryCQ
                  : [],
            };
            conditionalList.push(conditionalItem);
          });
        }

        if (item.is_subquestion == "yes") {
          var list = sec.CheckListInspections.filter(
            (x) => x.parent_id == item.id  && x?.type && x?.type == "subquestion"
          );
          var responseListSQ = [];
          list.map((item) => {
            console.log(item);
            //alert(JSON.stringify(item.ResponseSets))
            if (item.data_type == "Custom" || item.data_type == "Global") {
              item.ResponseSetInspections.map((r) => {
                var responseItem = {
                  id: r.response_id,
                  title: r.title,
                  position: r.position,
                };
                responseListSQ.push(responseItem);
              });

              console.log("ResponseList ***********************", responseList);
              //alert(JSON.stringify(item.ResponseSets))
              var responseLibrarySQ = { id: item.id, responses:  responseListSQ.sort(
                (a, b) => a.position - b.position
              ), };
            }
            var conditionalItem = {
              id: item.id,
              title: item.title,
              dataType: item.data_type,
              position: item.position,
              status: "added",
              mandatory: item.is_mandatory,
              multiselection: item.is_multiple_allowed,
              condition: item.condition,
              conditionValue: item.condition_value,
              conditional: item.is_conditional,
              is_subquestion: item.is_subquestion,
              type: item.type,
              parent: item.parent_id,
              isopen: "no",
              // conditionalList: [],
              // subQuestionList: [],
              responseLibrary:
                item.data_type == "Custom" || item.data_type == "Global"
                  ? responseLibrarySQ
                  : [],
            };
            subQuestionList.push(conditionalItem);
          });
        }


        var newChecklist = {
          id: item.id,
          title: item.title,
          section_id: sec.id,
          dataType: item.data_type,
          position: item.position,
          status: "added",
          mandatory: item.is_mandatory,
          multiselection: item.is_multiple_allowed,
          condition: item.condition,
          conditionValue: item.condition_value,
          conditional: item.is_conditional,
          is_subquestion: item.is_subquestion,
          type: item.type,
          parent: item.parent_id,
          isopen: "no",
          isopenSub: "no",
          conditionalList: conditionalList.sort(function(a, b) {
            return a.position - b.position;
          }),
          subQuestionList: subQuestionList.sort(function(a, b) {
            return a.position - b.position;
          }),
          responseLibrary:
            item.data_type === "Custom" || item.data_type === "Global"
              ? responseLibrary
              : [],
        };
        if (item.parent_id == null) checklist.push(newChecklist);

        if (inspection_answer.length !== 0) {
          // console.log("type edit", answers_obj_edit);
          var lookup = {};
          if (
            newChecklist.dataType === "Custom" ||
            newChecklist.dataType === "Global"
          ) {
            lookup = _.keyBy(
              answers_obj_edit[newChecklist.id]
                ? JSON.parse(
                    answers_obj_edit[newChecklist.id].value
                      ? answers_obj_edit[newChecklist.id].value
                      : "[]"
                  )
                : [],
              function(o) {
                return o;
              }
            );
          }
          console.log("[]{}()", answers_obj_edit[newChecklist.id]?.image);
          console.log("newChecklist",newChecklist)

          answers_obj_edit = {
            ...answers_obj_edit,
            [newChecklist.id]: {
              ...answers_obj_edit[newChecklist.id],
              dataType: newChecklist.dataType,
              mandatory: newChecklist.mandatory,
              parent: item.parent_id,
              conditionalList: newChecklist.conditionalList,
              subQuestionList: newChecklist.subQuestionList,
              responseLibrary: newChecklist.responseLibrary,
              conditional_obj: {}, // id: answers_obj_edit[newChecklist.id].id,
              video_old: answers_obj_edit[newChecklist.id]?.video,
              video: answers_obj_edit[newChecklist.id]?.video,
              image_old:
                newChecklist.dataType === "Photo" ||
                newChecklist.dataType === "Anotation"
                  ? answers_obj_edit[newChecklist.id]?.value
                  : answers_obj_edit[newChecklist.id]?.image,
              value:
                newChecklist.dataType == "Instruction"
                  ? "."
                  : newChecklist.dataType == "Custom" ||
                    newChecklist.dataType == "Global"
                  ? _.filter(newChecklist.responseLibrary.responses, function(
                      u
                    ) {
                      if (lookup[u.id] !== undefined) {
                        console.log(lookup[u.id], u.id);
                        return u;
                      }
                    }).filter((v) => v !== null)
                  : newChecklist.dataType === "Checkbox"
                  ? answers_obj_edit[newChecklist.id].value !== null
                    ? true
                    : null
                  : answers_obj_edit[newChecklist.id]
                  ? answers_obj_edit[newChecklist.id].value
                  : "",
            },
          };
        
        } else {

          console.log("newChecklist",newChecklist)
          answers_obj = {
            ...answers_obj,
            [newChecklist.id]: {
              dataType: newChecklist.dataType,
              mandatory: newChecklist.mandatory,
              conditionalList: newChecklist.conditionalList,
              subQuestionList: newChecklist.subQuestionList,
              responseLibrary: newChecklist.responseLibrary,
              check_id: newChecklist.id,
              parent: item.parent_id,
              conditional_obj: {},
              value:
                newChecklist.dataType !== ("Custom" || "Global")
                  ? newChecklist.dataType !== "Checkbox"
                    ? sec.title === "Title Page"
                      ? newChecklist.title === "Prepared by"
                        ? inspection.Schedule.User.first_name +
                          " " +
                          inspection.Schedule.User.last_name
                        : newChecklist.title === "Conducted on"
                        ? moment().format("MMMM DD, YYYY")
                        : ""
                      : ""
                    : null
                  : [],
            },
          };
        }
      });

      var sectionList = {
        template: { id: sec.id },
        list: checklist.sort(function(a, b) {
          return a.position - b.position;
        }),
      };

      var section = {
        id: sec.id,
        title: sec.title,
        type: sec.type,
        status: "added",
        position: sec.position,
        checklist: sectionList,
        score: sec.score,
      };
      sections.push(section);
    });

    let currentSectionId = template[globalIndex]?.id;

    console.log("LLLLLLLLLLLLLLLLLLLL", template);
    console.log(sections);

    let all_sections = [...template];
    let match_indx = all_sections.findIndex((x) => x.id === currentSectionId);
    console.log("match_indx >>>>>>", match_indx);
    if (match_indx != -1) {
      all_sections.splice(match_indx, 1, sections[0]);
    }
    console.log(all_sections);

    // =================================================================
    var blank_template = {
      sections: all_sections,
    };

    console.log(blank_template);

    await setTemplate(
      blank_template.sections.sort(function(a, b) {
        return a.position - b.position;
      })
    );

    if (inspection_answer.length === 0) {
      console.log("Sample4", answers_obj);
      setAnswers({ ...answers_obj, ...answers });
      handleSubmit({ ...answers_obj, ...answers }, inspection.id);
      // console.log("lolo");
    } else {
      console.log("Sample4", answers_obj_edit);
      setAnswers({ ...answers_obj_edit, ...answers });
    }
  };

  const getTemplate = async (
    id,
    inspection,
    inspection_answer,
    answers_obj_edit,
    sections_data,
    finalScore,
  ) => {
    var retrievedData = localStorage.getItem("UserData");
    var data = JSON.parse(retrievedData);
    console.log("()()()", id);
    var params = {
      template_id: id,
    };

    var token = data?.token;
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");
    await fetch(
      GlobalApi + "/TemplateInspection/get_template_details?" + query,
      {
        method: "GET",
        headers: new Headers({
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        }),
      }
    )
      .then((response) => response.json())
      .then(async (res) => {
        console.log(
          res,
          "[][][][][][][][][][][][][][][][][][][][][][][][][][][][][][][template",
          res
        );
        if (res.status === "Success") {
          // setCurrentEditSection(data.SectionInspections[0].id)
          var data = res.data;
          var sections = [];
          console.log(data);
          let answers_obj = {};
          // =================================================================
          await data.SectionInspections.map((sec) => {
            var checklist = [];
            console.log(sec,"()()()()()()()");
            sec.CheckListInspections.map((item) => {
           
              var responseList = [];
              var conditionalList = [];
              var subQuestionList = [];

              if (item.data_type === "Custom" || item.data_type === "Global") {
                item.ResponseSetInspections.map((r) => {
                  var item = {
                    id: r.id,
                    title: r.title,
                    position: r.position,
                  };
                  responseList.push(item);
                });
                var responseLibrary = {
                  id: item.id,
                  responses: responseList,
                };
              }

              if (item.is_conditional == "yes") {
                var list = sec.CheckListInspections.filter(
                  (x) => x.parent_id == item.id && x?.type !== "subquestion");
                  var responseListCQ = [];


                list.map((item) => {
                  console.log(item);
                  //alert(JSON.stringify(item.ResponseSets))
                  if (
                    item.data_type == "Custom" ||
                    item.data_type == "Global"
                  ) {
                    item.ResponseSetInspections.map((r) => {
                      var responseItem = {
                        id: r.response_id,
                        title: r.title,
                        position: r.position,
                      };
                      responseListCQ.push(responseItem);
                    });


                    var responseLibraryCQ = {
                      id: item.id,
                      responses: responseListCQ.sort(
                        (a, b) => a.position - b.position
                      ),
                    };
                  }
                  var conditionalItem = {
                    id: item.id,
                    title: item.title,
                    dataType: item.data_type,
                    position: item.position,
                    status: "added",
                    mandatory: item.is_mandatory,
                    multiselection: item.is_multiple_allowed,
                    condition: item.condition,
                    conditionValue: item.condition_value,
                    conditional: item.is_conditional,
                    is_subquestion: item.is_subquestion,
                    type: item.type,
                    parent: item.parent_id,
                    isopen: "no",
                    // conditionalList: [],
                    // subQuestionList: [],
                    responseLibrary:
                      item.data_type == "Custom" || item.data_type == "Global"
                        ? responseLibraryCQ
                        : [],
                  };
                  conditionalList.push(conditionalItem);
                });
                //alert(JSON.stringify(conditionalList))
              }

              if (item.is_subquestion == "yes") {
                var list = sec.CheckListInspections.filter(
                  (x) => x.parent_id == item.id && x.type && x.type == "subquestion");
                  var responseListSQ = [];


                list.map((item) => {
                  console.log(item);
                  //alert(JSON.stringify(item.ResponseSets))
                  if (
                    item.data_type == "Custom" ||
                    item.data_type == "Global"
                  ) {
                    item.ResponseSetInspections.map((r) => {
                      var responseItem = {
                        id: r.response_id,
                        title: r.title,
                        position: r.position,
                      };
                      responseListSQ.push(responseItem);
                    });


                    var responseLibrarySQ = {
                      id: item.id,
                      responses: responseListSQ.sort(
                        (a, b) => a.position - b.position
                      ),
                    };
                  }
                  var conditionalItem = {
                    id: item.id,
                    title: item.title,
                    dataType: item.data_type,
                    position: item.position,
                    status: "added",
                    mandatory: item.is_mandatory,
                    multiselection: item.is_multiple_allowed,
                    condition: item.condition,
                    conditionValue: item.condition_value,
                    conditional: item.is_conditional,
                    is_subquestion: item.is_subquestion,
                    type: item.type,
                    parent: item.parent_id,
                    isopen: "no",
                    // conditionalList: [],
                    // subQuestionList: [],
                    responseLibrary:
                      item.data_type == "Custom" || item.data_type == "Global"
                        ? responseLibrarySQ
                        : [],
                  };
                  subQuestionList.push(conditionalItem);
                });
                //alert(JSON.stringify(conditionalList))
              }

              var newChecklist = {
                id: item.id,
                title: item.title,
                section_id: sec.id,
                dataType: item.data_type,
                position: item.position,
                status: "added",
                mandatory: item.is_mandatory,
                multiselection: item.is_multiple_allowed,
                condition: item.condition,
                conditionValue: item.condition_value,
                conditional: item.is_conditional,
                is_subquestion: item.is_subquestion,
                type: item.type,
                parent: item.parent_id,
                isopen: "no",
                isopenSub: "no",
                conditionalList: conditionalList.sort(function(a, b) {
                  return a.position - b.position;
                }),
                subQuestionList: subQuestionList.sort(function(a, b) {
                  return a.position - b.position;
                }),
                responseLibrary:
                  item.data_type === "Custom" || item.data_type === "Global"
                    ? responseLibrary
                    : [],
              };

             
              
              if (item.parent_id == null) checklist.push(newChecklist);

              if (inspection_answer.length !== 0) {
                // console.log("type edit", answers_obj_edit);
                var lookup = {};
                if (
                  newChecklist.dataType === "Custom" ||
                  newChecklist.dataType === "Global"
                ) {
                  lookup = _.keyBy(
                    answers_obj_edit[newChecklist.id]
                      ? JSON.parse(
                          answers_obj_edit[newChecklist.id].value
                            ? answers_obj_edit[newChecklist.id].value
                            : "[]"
                        )
                      : [],
                    function(o) {
                      return o;
                    }
                  );
                }
                console.log("[]{}()", answers_obj_edit[newChecklist.id]?.image);
                console.log("newChecklist",newChecklist)

                answers_obj_edit = {
                  ...answers_obj_edit,
                  [newChecklist.id]: {
                    ...answers_obj_edit[newChecklist.id],
                    dataType: newChecklist.dataType,
                    mandatory: newChecklist.mandatory,
                    parent: item.parent_id,
                    conditionalList: newChecklist.conditionalList,
                    subQuestionList: newChecklist.subQuestionList,
                    responseLibrary: newChecklist.responseLibrary,
                    conditional_obj: {},
                    // id: answers_obj_edit[newChecklist.id].id,
                    video_old: answers_obj_edit[newChecklist.id]?.video,
                    video: answers_obj_edit[newChecklist.id]?.video,

                    image_old:
                      newChecklist.dataType === "Photo" ||
                      newChecklist.dataType === "Anotation"
                        ? answers_obj_edit[newChecklist.id]?.value
                        : answers_obj_edit[newChecklist.id]?.image,
                    value:
                      newChecklist.dataType == "Instruction"
                        ? "."
                        : newChecklist.dataType == "Custom" ||
                          newChecklist.dataType == "Global"
                        ? _.filter(
                            newChecklist.responseLibrary.responses,
                            function(u) {
                              if (lookup[u.id] !== undefined) {
                                console.log(lookup[u.id], u.id);
                                return u;
                              }
                            }
                          ).filter((v) => v !== null)
                        : newChecklist.dataType === "Checkbox"
                        ? answers_obj_edit[newChecklist.id].value !== null
                          ? true
                          : null
                        : answers_obj_edit[newChecklist.id]
                        ? answers_obj_edit[newChecklist.id].value
                        : "",
                  },
                };
                // console.log(
                //   // answers_obj_edit[newChecklist.id].image_old,
                //   answers_obj_edit[newChecklist.id].value,
                //   "CHECK CHECK",
                //   newChecklist.dataType
                // );
              } else {
                console.log("newChecklist",newChecklist)


                answers_obj = {
                  ...answers_obj,
                  [newChecklist.id]: {
                    dataType: newChecklist.dataType,
                    mandatory: newChecklist.mandatory,
                    conditionalList: newChecklist.conditionalList,
                    subQuestionList: newChecklist.subQuestionList,
                    responseLibrary: newChecklist.responseLibrary,
                    check_id: newChecklist.id,
                    parent: item.parent_id,
                    conditional_obj: {},
                    value:
                      newChecklist.dataType !== ("Custom" || "Global")
                        ? newChecklist.dataType !== "Checkbox"
                          ? sec.title === "Title Page"
                            ? newChecklist.title === "Prepared by"
                              ? inspection.Schedule.User.first_name +
                                " " +
                                inspection.Schedule.User.last_name
                              : newChecklist.title === "Conducted on"
                              ? moment().format("MMMM DD, YYYY")
                              : ""
                            : ""
                          : null
                        : [],
                  },
                };
              }
            });

            var sectionList = {
              template: { id: sec.id },
              list: checklist.sort(function(a, b) {
                return a.position - b.position;
              }),
            };

            console.log("sectionList>>>",sectionList)

            var section = {
              id: sec.id,
              title: sec.title,
              type: sec.type,
              status: "added",
              position: sec.position,
              checklist: sectionList,
              score: sec.score,
              loading:true,
            };

            sections.push(section);
          });

          // =================================================================
          var blank_template = {
            sections,
          };

          console.log(blank_template);
          let sortedTemp = blank_template.sections.sort(function(a, b) {
            return a.position - b.position;
          })

          console.log("sortedTemp",sortedTemp)

          if( sections_data == null){
            await setTemplate(
              sortedTemp
            );
          }else{
            updateInspectionScore(sortedTemp,sections_data,finalScore)
          }

         
         
          if (inspection_answer.length === 0) {
            setAnswers(answers_obj);
            handleSubmit(answers_obj, inspection.id);
            // console.log("lolo");
          } else {
            setAnswers(answers_obj_edit);
          }
          //alert(JSON.stringify(this.state.template))
        } else if (
          res.error === "jwt expired" ||
          res.error === "invalid token" ||
          res.error === "invalid signature" ||
          res.error === "Unexpected token"
        ) {
          let status = await refresh_token();
          console.log(status);
          if (status) {
          }
        }
      })
      .catch((err) => {
        // alert(err);
        console.log(err, "error");
      });
  };

  async function updateInspectionScore(templates_data,sections_data, finalScore) {
    var retrievedData = localStorage.getItem("UserData");
    var data = JSON.parse(retrievedData);
    console.log('Sections DATa *(((>>>', sections_data)

    let arr = [];
    for (const iterator1 of templates_data) {
      for (const iterator2 of sections_data) {
        if(iterator1.id === iterator2.section_id){
          let obj = {
            ...iterator1,
            score:iterator2.score,
            loading:false
          }
          arr.push(obj);
        }
    }
 }
 
let final= [];
//if missing objects in sections score array
 if (templates_data.length !== sections_data?.length) {
   let diff = templates_data.filter((x) => !sections_data.some((y) => x.id === y.section_id));

    final = diff.map((item) => {
     return { ...item, score: 0, loading: false };
   });
 }

 let final_arr = [...arr, ...final];
     
    let sortedTemplate = final_arr.sort(function (a, b) {
      return a.position - b.position;
    })
    console.log('Last ARRAY UPDATED >>>>>', sortedTemplate);
    // alert(1)
    setTemplate(sortedTemplate);
    setTotalScore(finalScore)
    return;

  }


  async function handleChangeText(value, id) {
    console.log(value, id);

    console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>", answers);

    let obj = {
      ...answers,
      [id]: {
        ...answers[id],
        value: value?.toString(),
      },
    };

    await setAnswers(obj);
  }

  async function handleMeta(value, id, name = "image") {
    console.log(value, id);

    if (name === "image") {
      await new Compressor(value, {
        quality: 0.6,
        convertSize: 0,
        async success(result) {
          if (result.size / 1024 / 1024 <= 10) {
            //alert(result.size / 1024 / 1024)
            let fileSize = result.size / 1024 / 1024 + currentFileSize;
            console.log(fileSize);
            if (fileSize < parseInt(packageDetails.package.file_size_per_user)) {
              let obj = {
                ...answers,
                [id]: {
                  ...answers[id],
                  image: result,
                  edited: true,
                  fileSize: result.size / 1024 / 1024,
                },
              };
              setAnswers(obj);
              setCurrentFileSize(fileSize);
            } else {
              swal(
                t("Storage Limit Exceeded"),
                t("Upload a small file or update your package"),
                "warning"
              );
            }
          } else {
            swal(
              t("File Size Exceeded"),
              t("File size should be 10 MB or less"),
              "warning"
            );
          }
        },
        error(err) {
          console.log(err.message);
        },
      });
    } else if (name == "multple-images") {
      var imgObj = { ...answers[id] };

      // For Enterprise
      if (packageDetails?.package?.id == "09b7b809-3f45-4439-9836-ba91b160174d") {
        if (imgObj.imageslist.length + value.length > 5) {
          swal(t("Upload Limit Reached"), t("Maximum 5 Images Allowed"), "warning");
        } else {
          var compressFiles = imgObj.imageslist ? imgObj.imageslist : [];
          var fileSize = 0;
          for (let img of value) {
            await new Compressor(img, {
              quality: 0.6,
              convertSize: 0,
              success(result) {
                if (result.size / 1024 / 1024 <= 10) {
                  fileSize = result.size / 1024 / 1024 + fileSize;
                  //alert(result.size / 1024 / 1024)

                  if (fileSize < parseInt(packageDetails?.package?.file_size_per_user)) {
                    var objImg = {
                      url: "",
                      key: "",
                      image: result,
                      status: "New",
                      size: result.size,
                    };
                    compressFiles.push(objImg);
                    let obj = {
                      ...answers,
                      [id]: {
                        ...answers[id],
                        ismultiple: true,
                        imageslist: compressFiles,
                        imageslistsize: fileSize,
                        edited: true,
                      },
                    };
                    setAnswers(obj);
                    setCurrentFileSize(fileSize + currentFileSize);
                  } else {
                    swal(
                      t("Storage Limit Exceeded"),
                      t("Upload a small file or update your package"),
                      "warning"
                    );
                  }
                } else {
                  swal(
                    t("File Size Exceeded"),
                    t("File size should be 10 MB or less"),
                    "warning"
                  );
                }
              },
            });
          }
        }
      }

      // For Small/Medium
      if (packageDetails?.package?.id == "b89044a0-5314-4eda-816d-2969083ad4f4") {
        if (imgObj.imageslist.length + value.length > 3) {
          swal(t("Upload Limit Reached"), t("Maximum 3 Images Allowed"), "warning");
        } else {
          var compressFiles = imgObj.imageslist ? imgObj.imageslist : [];
          var fileSize = 0;
          for (let img of value) {
            await new Compressor(img, {
              quality: 0.6,
              convertSize: 0,
              success(result) {
                if (result.size / 1024 / 1024 <= 10) {
                  fileSize = result.size / 1024 / 1024 + fileSize;
                  //alert(result.size / 1024 / 1024)

                  if (fileSize < parseInt(packageDetails?.package?.file_size_per_user)) {
                    var objImg = {
                      url: "",
                      key: "",
                      image: result,
                      status: "New",
                      size: result.size,
                    };
                    compressFiles.push(objImg);
                    let obj = {
                      ...answers,
                      [id]: {
                        ...answers[id],
                        ismultiple: true,
                        imageslist: compressFiles,
                        imageslistsize: fileSize,
                        edited: true,
                      },
                    };
                    setAnswers(obj);
                    setCurrentFileSize(fileSize + currentFileSize);
                  } else {
                    swal(
                      t("Storage Limit Exceeded"),
                      t("Upload a small file or update your package"),
                      "warning"
                    );
                  }
                } else {
                  swal(
                    t("File Size Exceeded"),
                    t("File size should be 10 MB or less"),
                    "warning"
                  );
                }
              },
            });
          }
        }
      }

      // For Free
      if (packageDetails?.package?.id == "85232b2e-3301-4a8e-bd6e-d1f00c7dd1b5") {
        if (imgObj.imageslist.length + value.length > 2) {
          swal(t("Upload Limit Reached"), t("Maximum 2 Images Allowed"), "warning");
        } else {
          var compressFiles = imgObj.imageslist ? imgObj.imageslist : [];
          var fileSize = 0;
          for (let img of value) {
            await new Compressor(img, {
              quality: 0.6,
              convertSize: 0,
              success(result) {
                if (result.size / 1024 / 1024 <= 10) {
                  fileSize = result.size / 1024 / 1024 + fileSize;
                  //alert(result.size / 1024 / 1024)

                  if (fileSize < parseInt(packageDetails?.package?.file_size_per_user)) {
                    var objImg = {
                      url: "",
                      key: "",
                      image: result,
                      status: "New",
                      size: result.size,
                    };
                    compressFiles.push(objImg);
                    let obj = {
                      ...answers,
                      [id]: {
                        ...answers[id],
                        ismultiple: true,
                        imageslist: compressFiles,
                        imageslistsize: fileSize,
                        edited: true,
                      },
                    };
                    setAnswers(obj);
                    setCurrentFileSize(fileSize + currentFileSize);
                  } else {
                    swal(
                      t("Storage Limit Exceeded"),
                      t("Upload a small file or update your package"),
                      "warning"
                    );
                  }
                } else {
                  swal(
                    t("File Size Exceeded"),
                    t("File size should be 10 MB or less"),
                    "warning"
                  );
                }
              },
            });
          }
        }
      }
    } else if (name == "video") {
      if (value.size / 1024 / 1024 <= 10) {
        let fileSize = value.size / 1024 / 1024 + currentFileSize;
        console.log(fileSize);
        if (fileSize < parseInt(packageDetails?.package?.file_size_per_user)) {
          console.log(value);
          let obj = {
            ...answers,
            [id]: {
              ...answers[id],
              [name]: value,
              videoEdited: true,
              fileSize: value.size / 1024 / 1024,
            },
          };
          setAnswers(obj);
          setCurrentFileSize(fileSize);
        } else {
          swal(
            t("Storage Limit Exceeded"),
            t("Upload a small file or update your package"),
            "warning"
          );
        }
      } else {
        swal(
          t("File Size Exceeded"),
          t("File size should be 10 MB or less"),
          "warning"
        );
      }
    } else {
      let obj = {
        ...answers,
        [id]: {
          ...answers[id],
          [name]: value,
          edited: true,
        },
      };
      setAnswers(obj);
    }
  }

  async function handleFile(value, id) {
    console.log(value, id);

    await new Compressor(value, {
      quality: 0.6,
      convertSize: 0,
      async success(result) {
        if (result.size / 1024 / 1024 <= 10) {
          let fileSize = result.size / 1024 / 1024 + currentFileSize;
          console.log(fileSize);
          if (fileSize < parseInt(packageDetails?.package?.file_size_per_user)) {
            let obj = {
              ...answers,
              [id]: {
                ...answers[id],
                value: result,
                edited: true,
                fileSize: result.size / 1024 / 1024,
              },
            };
            setAnswers(obj);
            setCurrentFileSize(fileSize);
          } else {
            swal(
              t("Storage Limit Exceeded"),
              t("Upload a small file or update your package"),
              "warning"
            );
          }
        } else {
          swal(
            t("File Size Exceeded"),
            t("File size should be 10 MB or less"),
            "warning"
          );
        }
      },
      error(err) {
        console.log(err.message);
      },
    });
  }

  function handleChangeCustom(value, id, isMultiple) {
    console.log(value, id, answers[id].value);

    // return
    let arr = [];
    if (isMultiple === true) {
      arr = answers[id].value ? answers[id].value : [];
    }

    if (arr.indexOf(value) === -1) {
      // console.log(arr.indexOf())
      arr.push(value);
    } else {
      arr.splice(arr.indexOf(value), 1);
    }
    var uniq = arr.reduce(function(a, b) {
      if (a.indexOf(b) < 0) a.push(b);
      return a;
    }, []);

    let obj = {
      ...answers,
      [id]: {
        ...answers[id],
        value: uniq,
      },
    };

    setAnswers(obj);
  }

  async function handleSubmit(answersObj, inspection_id) {
    var retrievedData = localStorage.getItem("UserData");
    var data = JSON.parse(retrievedData);

    var token = data?.token;
    let keys = answersObj ? Object?.keys(answersObj) : [];
    let final_arr = [];
    keys.map(async (v, i) => {
      // console.log(answersObj[v].value);
      if (answersObj[v].dataType === ("Custom" || "Global")) {
        let custom_val = [];

        if (answersObj[v].value.length === 0) {
          final_arr.push({
            ...answersObj[v],
            parent_id: answersObj[v].parent,
            value: JSON.stringify(custom_val),
          });
        } else {
          answersObj[v].value.map((val, index) => {
            custom_val.push(val.id);
            if (answersObj[v].value.length - 1 === index) {
              final_arr.push({
                ...answersObj[v],
                parent_id: answersObj[v].parent,
                value: JSON.stringify(custom_val),
              });
            }
          });
        }
      } else if (answersObj[v].dataType === "Checkbox") {
        final_arr.push({
          ...answersObj[v],
          parent_id: answersObj[v].parent,
          value: answersObj[v].value?.toString(),
        });
      } else if (
        answersObj[v].dataType === "Anotation" ||
        answersObj[v].dataType === "Photo"
      ) {
        console.log("ANOTATION", answersObj[v].value);
        if (answersObj[v].edited) {
          const imgData = new FormData();
          imgData.append("images", answersObj[v].value);

          let imageReq = await fetch(
            GlobalApi + "/InspectionAnswer/add_images",
            {
              method: "Post",
              headers: new Headers({
                Authorization: "Bearer " + token,
                // "Content-Type": "application/json",
              }),
              body: imgData,
            }
          );

          let resJson = await imageReq.json();
          console.log("______-------______", resJson);
          final_arr.push({
            ...answersObj[v],
            value: resJson.data,
            parent_id: answersObj[v].parent,
          });
        } else {
          final_arr.push({ ...answersObj[v] });
        }
      } else {
        final_arr.push(answersObj[v]);
      }

      if (keys.length - 1 === i) {
        console.log(final_arr);

        final_arr.map(async (value, valIndex) => {
          let request = await fetch(
            GlobalApi + "/InspectionAnswer/create_inspection_answer",
            {
              method: "Post",
              headers: new Headers({
                Authorization: "Bearer " + token,
                "Content-Type": "application/json",
              }),
              body: JSON.stringify({
                ...value,
                parent_id: answersObj[v].parent,
                inspection_id: inspection_id,
              }),
            }
          );

          let resJson = await request.json();

          console.log(resJson);
          if (final_arr.length - 1 === valIndex) {
            getInspection();
            // swal(t("Success"), "Inspection Saved", "success");
          }
        });
      }
    });
  }

  function handleEdit(IsAlert) {
    // alert("handle Edit Called")
    let _answers = { ...answers };

    

    let currentSectionId = template[globalIndex]?.id;
    let currentChecklists = [];
    let answers_new = {};
    for (let i of template[globalIndex].checklist?.list) {
      currentChecklists.push(i.id);
      answers_new[i.id] = _answers[i.id];
      console.log("apples",_answers[i.id])
      
      
      if (i.conditionalList.length > 0) {
        for (let j of i.conditionalList) {
          currentChecklists.push(j.id);
          answers_new[j.id] = _answers[j.id];
        
        }
      
      }

      if (i.subQuestionList.length > 0) {
        for (let j of i.subQuestionList) {
          currentChecklists.push(j.id);
          answers_new[j.id] = _answers[j.id];
        }
      
      }
    }

    console.log("Samplekkk 3", answers_new);

    // find if any object in answers_new whose datatype is not signature or instruction has mandatory true and !value

    let mandatory_answers = [];
    for (let i of Object.keys(answers_new)) {
      if (answers_new[i].mandatory === true && !answers_new[i].value && answers_new[i].dataType !== "Instruction" && answers_new[i].dataType !== "Signature" && !answers_new[i].parent) {
        mandatory_answers.push(answers_new[i]);
      }
    }
    console.log("mandatory_answers", mandatory_answers);

    if(mandatory_answers.length > 0) {

      swal(t("Error"), t("Please fill all mandatory fields"), "error");
      return;
    }

    var retrievedData = localStorage.getItem("UserData");
    var data = JSON.parse(retrievedData);

    var token = data?.token;
    let keys = Object.keys(answers_new);
    let final_arr = [];
    let obj = { ...answers_new };
    setSpinner(true);

    try {
      keys.map(async (v, i) => {
        if (currentChecklists.indexOf(v) > -1) {
          if (
            answers_new[v] &&
            answers_new[v].video &&
            answers_new[v].video.name
          ) {
            const imgData = new FormData();
            imgData.append("video_old", answers_new[v].video_old);
            imgData.append("videos", answers_new[v].video);
            imgData.append("name", v);
            imgData.append("company_id", company.id);
            imgData.append("user_id", data.user_id);

            let imageReq = await fetch(
              GlobalApi + "/InspectionAnswer/video_upload",
              {
                method: "Post",
                headers: new Headers({
                  Authorization: "Bearer " + token,
                }),
                body: imgData,
              }
            );

            let imageJson = await imageReq.json();

            // console.log(imageJson, "[JSON REQ]");
            await fetch(GlobalApi + "/ConfigFileSize/create_file_size", {
              method: "Post",
              headers: new Headers({
                Authorization: "Bearer " + token,
                "Content-Type": "application/json",
              }),
              body: JSON.stringify({
                inspection_id: inspection.id,
                old_url: answers_new[v]?.video_old,
                file_size: answers_new[v]?.video?.size,
                file_type: "video",
                file_url: imageJson.data.Key,
                inspection_answer_id: answers_new[v]?.inspection_answer_id,
                organization_id: data.organization_id,
                user_id: data.user_id,
                identifier: "inspection",
              }),
            });

            obj = {
              ...obj,
              [v]: {
                ...obj[v], // video: imageJson.data.Key,
                video_old: imageJson.data.Key,
                editedVideo: false,
              },
            };

            // let resJson = await imageReq.json();
            answers_new[v].video = imageJson.data.Key;
            answers_new[v].videoEdited = null;
          }

          if (
            answers_new[v].dataType === "Custom" ||
            answers_new[v].dataType === "Global"
          ) {
            let custom_val = [];
            // console.log(answers[v].video);
            if (
              answers_new[v] &&
              answers_new[v].image &&
              answers_new[v].image.name
            ) {
              const imgData = new FormData();
              imgData.append("image_old", answers_new[v].image_old);

              imgData.append("images", answers_new[v].image);
              imgData.append("name", v);
              imgData.append("company_id", company.id);
              imgData.append("user_id", data.user_id);

              // console.log("COMPRESSED", answers_new[v].image.size);
              let imageReq = await fetch(
                GlobalApi + "/InspectionAnswer/image_upload",
                {
                  method: "Post",
                  headers: new Headers({
                    Authorization: "Bearer " + token,
                  }),
                  body: imgData,
                }
              );
              let resJson = await imageReq.json();
              console.log(resJson, "img 1");
              await fetch(GlobalApi + "/ConfigFileSize/create_file_size", {
                method: "Post",
                headers: new Headers({
                  Authorization: "Bearer " + token,
                  "Content-Type": "application/json",
                }),
                body: JSON.stringify({
                  inspection_id: inspection.id,
                  file_size: answers_new[v]?.image?.size,
                  old_url: answers_new[v]?.image_old,
                  file_type: "image",
                  inspection_answer_id: answers_new[v]?.inspection_answer_id,
                  organization_id: data.organization_id,

                  user_id: data.user_id,
                  identifier: "inspection",
                  file_url: resJson.data,
                }),
              });

              // let resJson = await imageReq.json();
              answers_new[v].image = resJson.data;

              obj = {
                ...obj,
                [v]: {
                  ...obj[v],
                  image: resJson.data,
                  image_old: resJson.data,
                  edited: false,
                },
              };
            }

            if (answers_new[v].value.length === 0) {
              // console.log(answers[v].value, "LENGTH 0");
              final_arr.push({
                ...answers_new[v],
                parent_id: answers_new[v].parent,
                value: JSON.stringify(custom_val),
                video:  (answers_new[v] && answers_new[v].video && answers_new[v].video_key) ?  answers_new[v].video_key : null,
                image: obj[v].image,
              });
            } else {
              answers_new[v].value.map(async (val, index) => {
                // console.log(val, "LENGTH");

                custom_val.push(val.id);
                if (answers_new[v].value.length - 1 === index) {
                  // console.log(custom_val, "CUSTOM VALUE");

                  final_arr.push({
                    ...answers_new[v],
                    parent_id: answers_new[v].parent,
                    video:  (answers_new[v] && answers_new[v].video && answers_new[v].video_key) ?  answers_new[v].video_key : null,
                    value: JSON.stringify(custom_val),
                    image: obj[v].image,
                  });
                }
              });
            }
          } else if (answers_new[v].dataType === "Checkbox") {
            final_arr.push({
              ...answers_new[v],
              parent_id: answers_new[v].parent,
              value: answers_new[v].value?.toString(),
            });
          } else if (answers_new[v].dataType === "Signature") {
            if (
              answers_new[v] &&
              answers_new[v].image &&
              answers_new[v].image.name
            ) {
              const imgData = new FormData();
              imgData.append("image_old", answers_new[v].image_old);

              imgData.append("images", answers_new[v].image);
              imgData.append("name", v);
              imgData.append("company_id", company.id);
              imgData.append("user_id", data.user_id);
              // console.log(result.size, "COMPRESSED", answers[v].image.size);
              let imageReq = await fetch(
                GlobalApi + "/InspectionAnswer/image_upload",
                {
                  method: "Post",
                  headers: new Headers({
                    Authorization: "Bearer " + token,
                    // "Content-Type": "application/json",
                  }),
                  body: imgData,
                }
              );

              let resJson = await imageReq.json();

              await fetch(GlobalApi + "/ConfigFileSize/create_file_size", {
                method: "Post",
                headers: new Headers({
                  Authorization: "Bearer " + token,
                  "Content-Type": "application/json",
                }),
                body: JSON.stringify({
                  inspection_id: inspection.id,
                  file_size: answers_new[v]?.image?.size,
                  file_type: "image",
                  old_url: answers_new[v]?.image_old,

                  file_url: resJson.data,
                  inspection_answer_id: answers_new[v]?.inspection_answer_id,
                  organization_id: data.organization_id,
                  user_id: data.user_id,
                  identifier: "inspection",
                }),
              });

              answers_new[v].image = resJson.data;

              obj = {
                ...obj,
                [v]: {
                  ...obj[v],
                  image: resJson.data,
                  image_old: resJson.data,
                  edited: false,
                },
              };
            }

            final_arr.push({
              ...answers_new[v],
              parent_id: answers_new[v].parent,
              // image: resJson.data,
            });
          } else if (answers_new[v].dataType === "Checkbox") {
            final_arr.push({
              ...answers_new[v],
              parent_id: answers_new[v].parent,
              value: parseInt(answers_new[v].value),
            });
          } else if (
            answers_new[v].dataType === "Anotation" ||
            answers_new[v].dataType === "Photo"
          ) {
            const imgData = new FormData();
            // console.log("ANOTATION", answers[v].value);
            if (answers_new[v].edited) {
              imgData.append("images", answers_new[v].value);
              imgData.append("image_old", answers_new[v].image_old);
              imgData.append("name", v);
              imgData.append("company_id", company.id);
              imgData.append("user_id", data.user_id);
              let req = await fetch(
                GlobalApi + "/InspectionAnswer/image_upload",
                {
                  method: "Post",
                  headers: new Headers({
                    Authorization: "Bearer " + token,
                  }),
                  body: imgData,
                }
              );

              let reqJson = await req.json();

              await fetch(GlobalApi + "/ConfigFileSize/create_file_size", {
                method: "Post",
                headers: new Headers({
                  Authorization: "Bearer " + token,
                  "Content-Type": "application/json",
                }),
                body: JSON.stringify({
                  inspection_id: inspection.id,
                  file_size: answers_new[v]?.value?.size,
                  file_type: "image",
                  file_url: reqJson.data,
                  inspection_answer_id: answers_new[v]?.inspection_answer_id,
                  organization_id: data.organization_id,
                  user_id: data.user_id,
                  identifier: "inspection",
                }),
              });

              obj = {
                ...obj,
                [v]: {
                  ...obj[v],
                  value: reqJson.data,
                  image_old: reqJson.data,
                  edited: false,
                },
              };

              final_arr.push({
                ...answers_new[v],
                parent_id: answers_new[v].parent,
                value: reqJson.data,
              });
            } else {
              final_arr.push({
                ...answers_new[v],
                parent_id: answers_new[v].parent,
              });
            }
          } else {
            // console.log(answers[v].dataType);
            if(answers_new[v] && answers_new[v].video && answers_new[v].video_key){
              final_arr.push({
                ...answers_new[v],
                parent_id: answers_new[v].parent,
                video: answers_new[v].video_key
              });

            }else{

            final_arr.push({
              ...answers_new[v],
              parent_id: answers_new[v].parent,
            });
          }
          }

          console.log("final_arr",final_arr)
          // console.log("final chack ___", final_arr);
          if (keys.length - 1 === final_arr.length - 1) {
            final_arr.map(async (value, valIndex) => {
              // console.log("test______________________________________", value);
              let request = await fetch(
                GlobalApi + "/InspectionAnswer/edit_inspection_answer",
                {
                  method: "Post",
                  headers: new Headers({
                    Authorization: "Bearer " + token,
                    "Content-Type": "application/json",
                  }),
                  body: JSON.stringify({
                    ...value,
                  }),
                }
              );

              let resJson = await request.json();
              console.log("resJson_________________________", resJson);
              if (value.ismultiple) {
                const imgData = new FormData();
                var imgArry = [];
                var sizeArray = [];
                var newImgcount = 0;
                await value.imageslist.map((img) => {
                  if (img.status == "New") {
                    sizeArray.push(img.size);

                    imgData.append("images", img.image);
                    newImgcount++;
                  } else {
                    imgArry.push(img.key);
                  }
                });

                //if(newImgcount >0){
                imgData.append("inspection_id", inspection.id);
                imgData.append(
                  "inspection_answer_id",
                  value?.inspection_answer_id
                );
                imgData.append("fileSize", JSON.stringify(sizeArray));
                imgData.append("old_images", JSON.stringify(imgArry));
                imgData.append("company_id", company.id);
                imgData.append("user_id", data.user_id);
                imgData.append("is_multiple", value.ismultiple);

                let imageReq = await fetch(
                  GlobalApi +
                    "/InspectionAnswer/edit_inspection_answer_multiple_images",
                  {
                    method: "Post",
                    headers: new Headers({
                      Authorization: "Bearer " + token,
                    }),
                    body: imgData,
                  }
                );

                let imageJson = await imageReq.json();

                //alert(JSON.stringify(imageJson))
                //}
                getFileSize();
                getInspection();
              }
              if (final_arr.length - 1 == valIndex) {
                getFileSize();
                console.log("Sample3", { ...answers, ...obj });
                setAnswers({ ...answers, ...obj });
                    let params = {
                    inspection_id: id,
                    section_id: currentSectionId,
                  };

                  console.log("currentSectionId", currentSectionId);
                  console.log("currentInspectionId", id);
                  let query = Object.keys(params)
                    .map(
                      (k) =>
                        encodeURIComponent(k) +
                        "=" +
                        encodeURIComponent(params[k])
                    )
                    .join("&");

                  fetch(
                    GlobalApi +
                      "/InspectionAnswer/update_inspection_score?" +
                      query,
                    {
                      method: "GET",
                      headers: {
                        Authorization: "Bearer " + token,
                        "Content-Type": "application/json",
                      },
                    }
                  )
                    .then((responseJson) => responseJson.json())
                    .then(async (response) => {
                      console.log(
                        "::::::::::::::::::::::::>>>>>>>>>>>>",
                        response
                      );
                      if (response.msg == "success") {
                        
                        if (!IsAlert) {
                          console.log("No Alert");
                          setSpinner(false);
                        } else {
                        swal(t("Success"), t("Section is saved succesfully"), "success");
                        setSpinner(false);
                        }
                        // getInspection();
                        getInspectionNew(
                          response.SectionInspections,
                          response.InspectionAnswers
                        );
                      } else {
                        swal(t("Error"), t("Error In Saving Inspection"), "error");
                      }
                    })
                    .catch((error) => {
                      console.log(error);
                    });
                
              }
            });
          }
        }
      });
    } catch (e) {
      console.log(e);
    }
  }

  function handleCondText(value, id, parent_id) {
    console.log(value, id, parent_id);
  }

  async function handleComplete() {
    swal({
      title:t("Are you Sure?"),
      text: t("you won't be able to edit the inspection once completed"),
      icon: "warning",
      buttons: [t("No, cancel it!"), t("Yes, I am sure!")],
      dangerMode: true,
    }).then(async function(isConfirm) {
      if (isConfirm) {
        var retrievedData = localStorage.getItem("UserData");
        var data = JSON.parse(retrievedData);
    
        var token = data?.token;
    
        let request = await fetch(GlobalApi + "/Inspection/inspection_completed", {
          method: "Post",
          headers: new Headers({
            Authorization: "Bearer " + token,
            "Content-Type": "application/json",
          }),
          body: JSON.stringify({
            isCompleted: true,
            completed_date: new Date(),
            inspection_id: inspection.id,
            user_id: data.user_id,
            company_id: company.id,
            email_format: `${inspection?.Schedule?.title} by ${
              inspection?.User.first_name
            } ${inspection?.User.last_name} / ${moment(inspection.createdAt).format(
              "MMMM DD, YYYY"
            )}`,
            url: "https://app.uraudits.com/",
            previous_hierarchy_position: null,
            site_id: inspection?.Schedule.site,
          }),
        });
    
        let resJson = await request.json();
        console.log(resJson);
        if(resJson.msg == "success"){
          swal(t("Success"), t("Inspection Marked as Complete"), "success");
          setInspection({
            ...inspection,
            isCompleted: true,
          });
        }else{
          swal(t("Error"), t("Something went wrong"), "error");
        }

      } else {
        console.log("Canceled");
      }
    });
    // console.log("complete");

  }

  async function handleComment(status) {
    var retrievedData = localStorage.getItem("UserData");
    var data = JSON.parse(retrievedData);

    var token = data?.token;

    let obj = {
      inspection_id: inspection.id,
      status,
      comment: comment,
      user_id: inspection.created_by,
      reviewer_id: data.user_id,
      company_id: company.id,
      hierarchy_organization_id: isReview,
      site_id: inspection?.Schedule.site,
      email_format: `${inspection?.Schedule?.title} by ${
        inspection?.User.first_name
      } ${inspection?.User.last_name} / ${moment(inspection.createdAt).format(
        "MMMM DD, YYYY"
      )}`,
      review_by: `${user?.first_name} ${user?.last_name} / ${moment(
        new Date()
      ).format("MMMM DD, YYYY")}`,
      url: "https://app.uraudits.com/",
    };

    let request = await fetch(
      GlobalApi + "/InspectionComment/create_inspection_comment",
      {
        method: "Post",
        headers: new Headers({
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        }),
        body: JSON.stringify(obj),
      }
    );

    let resJson = await request.json();

    let requestnew = await fetch(
      GlobalApi + "/Inspection/inspection_comment_added",
      {
        method: "Post",
        headers: new Headers({
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        }),
        body: JSON.stringify(obj),
      }
    );
    setComment("");
    getInspection();
  }
  console.log(globalIndex);

  const handlePdfDownload = async (isCompleted,pdf_url) => {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let params = {
      user_id: data.user_id,
      inspection_id: inspection.id,
      url: GlobalApi.replace("api", ""),
    };

    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");
    // console.log(query)
    

    if (packageDetails.pdf_request_status === "Request is Valid") {
      console.log("CREATE PDF NEW_______________________________", isCompleted);

      if (isCompleted == "true" || (pdf_url !== null && pdf_url !== undefined)) {
        let pdfData = await fetch(
          GlobalApi + "/Inspection/create-pdf?" + query,
          {
            method: "GET",
            headers: {
              Authorization: "Bearer " + token,
              "Content-Type": "application/json",
            },
          }
        );
        let pdfDataJson = await pdfData.json();
        console.log("pdfData", pdfDataJson.pdf_url);
        window.open(pdfDataJson.pdf_url, '_blank');
        setBtnLoader(false);
      } else {
  let pdfData = await fetch(
          GlobalApi + "/Inspection/create-pdf?" + query,
          {
            method: "GET",
            headers: {
              Authorization: "Bearer " + token,
              "Content-Type": "application/json",
            },
          }
        );

        const blob = await pdfData.blob();
        // setwaitForResponseWithOverlay( false );

        // const fileURL = URL.createObjectURL( blob );
        
  
        await saveAs(blob);
        // await saveAs(GlobalApi + "/Inspection/create-pdf?" + query);
        setBtnLoader(false);
      }



      // let pdfData = await fetch(
      //   GlobalApi + "/Inspection/create-pdf?" + query,
      //   {
      //     method: "GET",
      //     headers: {
      //       Authorization: "Bearer " + token,
      //       "Content-Type": "application/json",
      //     },
      //   }
      // );
      // let pdfDataJson = await pdfData.json();
      // console.log("pdfData", pdfDataJson.pdf_url);
      // window.open(pdfDataJson.pdf_url, '_blank');
      // setBtnLoader(false);

      // await saveAs(GlobalApi + "/Inspection/create-pdf?" + query);
      // setBtnLoader(false);
    } else {
      swal(t("Warning"), packageDetails.pdf_request_status, "warning");
    }
  };

  if (localStorage.getItem("UserData") === null && isReview !== "edit") {
    return (
      <Redirect
        to={{
          pathname: "/signin",
          search: `?inspection=${id}&review=${isReview}&route=inspection-edit`,
        }}
      />
    );
  }

  async function handleDeleteVideo(value, id) {
    var retrievedData = localStorage.getItem("UserData");
    var data = JSON.parse(retrievedData);
    var token = data.token;
    if (value == "") {
      let req = await fetch(GlobalApi + "/InspectionAnswer/delete_s3_object", {
        method: "Post",
        headers: new Headers({
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        }),
        body: JSON.stringify({
          Key: answers[id].video_key,
        }),
      });

      let reqJson = await req.json();
      if (reqJson.status == "Success") {
        // try {
        // console.log({
        //   inspection_answer_id: answers[id].inspection_answer_id,
        //   inspection_id: answers[id].inspection_id,
        //   updated_by: data.user_id,
        //   video: '',
        // });
        let editReq = await fetch(
          GlobalApi + "/InspectionAnswer/edit_inspection_answer",
          {
            method: "Post",
            headers: new Headers({
              Authorization: "Bearer " + token,
              "Content-Type": "application/json",
            }),
            body: JSON.stringify({
              inspection_answer_id: answers[id].inspection_answer_id,
              inspection_id: answers[id].inspection_id,
              updated_by: data.user_id,
              video: null,
            }),
          }
        );

        let editReqJson = await editReq.json();
        console.log(editReqJson, "edit");
        // } catch (err) {
        //   console.log(err);
        // }

        let fileReq = await fetch(
          GlobalApi + "/ConfigFileSize/delete_file_size",
          {
            method: "Post",
            headers: new Headers({
              Authorization: "Bearer " + token,
              "Content-Type": "application/json",
            }),
            body: JSON.stringify({
              file_url: answers[id].video_key,
            }),
          }
        );

        let fileReqJson = await fileReq.json();

        console.log(fileReqJson, "file");

        getFileSize();
        swal(t("Success"), t("Video deleted successfully"), "success");

        let obj = {
          ...answers,
          [id]: {
            ...answers[id],
            video: null,
            editedVideo: null,
          },
        };

        setAnswers(obj);
        return;
      } else if (reqJson.err == "No Key Found") {
        console.log("wrorking");
        let obj = {
          ...answers,
          [id]: {
            ...answers[id],
            video: null,
            editedVideo: value ? true : false,
          },
        };
        console.log(currentFileSize, answers[id].fileSize);
        setCurrentFileSize(
          currentFileSize -
            (parseInt(answers[id].fileSize) ? answers[id].fileSize : 0)
        );
        swal(t("Success"), t("Video deleted successfully"), "success");
        setAnswers(obj);
        return;
      }
    }
  }

  async function handleDeleteImage(id, image = "value") {
    var retrievedData = localStorage.getItem("UserData");
    var data = JSON.parse(retrievedData);
    var token = data.token;
    console.log("YEYEYE", id, image, answers[id]);
    let req = await fetch(GlobalApi + "/InspectionAnswer/delete_s3_object", {
      method: "Post",
      headers: new Headers({
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify({
        Key: answers[id].image_old,
      }),
    });

    let reqJson = await req.json();
    console.log(reqJson);
    if (reqJson.status == "Success") {
      // try {
      // console.log({
      //   inspection_answer_id: answers[id].inspection_answer_id,
      //   inspection_id: answers[id].inspection_id,
      //   updated_by: data.user_id,
      //   video: '',
      // });
      let editReq = await fetch(
        GlobalApi + "/InspectionAnswer/edit_inspection_answer",
        {
          method: "Post",
          headers: new Headers({
            Authorization: "Bearer " + token,
            "Content-Type": "application/json",
          }),
          body: JSON.stringify({
            inspection_answer_id: answers[id].inspection_answer_id,
            inspection_id: answers[id].inspection_id,
            updated_by: data.user_id,
            [image]: null,
          }),
        }
      );

      let editReqJson = await editReq.json();
      console.log(editReqJson, "edit", answers[id].image_old);
      // } catch (err) {
      //   console.log(err);
      // }

      let fileReq = await fetch(
        GlobalApi + "/ConfigFileSize/delete_file_size",
        {
          method: "Post",
          headers: new Headers({
            Authorization: "Bearer " + token,
            "Content-Type": "application/json",
          }),
          body: JSON.stringify({
            file_url: answers[id].image_old,
          }),
        }
      );

      let fileReqJson = await fileReq.json();

      console.log(fileReqJson, "file");
      let obj = {
        ...answers,
        [id]: {
          ...answers[id],
          [image]: null,
          edited: false,
        },
      };

      setAnswers(obj);
      getFileSize();
      swal(t("Success"), t("Image deleted successfully"), "success");
    } else if (reqJson.err == "No Key Found") {
      console.log("wrorking");
      let obj = {
        ...answers,
        [id]: {
          ...answers[id],
          [image]: null,
          edited: false,
        },
      };
      setCurrentFileSize(
        currentFileSize -
          (parseInt(answers[id].fileSize) ? answers[id].fileSize : 0)
      );
      swal(t("Success"), t("Image deleted successfully"), "success");
      setAnswers(obj);
      return;
    }
  }

  // console.log(template, answers);
  async function handleDeleteMultipleImage(id, index) {
    var imgObj = { ...answers[id] };
    var imagelist = imgObj.imageslist;
    var imagelistsize = imgObj.imageslistsize;
    //alert(imgObj.imageslist[index].key)
    //alert(imgObj.inspection_answer_id)
    if (imagelist[index].status == "New") {
      imagelistsize = currentFileSize - imagelist[index].size / 1024 / 1024;
      imagelist.splice(index, 1);

      var IsMultiple = true;
      if (imagelist.length == 0) IsMultiple = false;
      let obj = {
        ...answers,
        [id]: {
          ...answers[id],
          ismultiple: IsMultiple,
          imageslist: imagelist,
          imageslistsize: imagelistsize,
        },
      };
      setCurrentFileSize(imagelistsize);
      setAnswers(obj);
    } else {
      setSpinner(true);
      var retrievedData = localStorage.getItem("UserData");
      var data = JSON.parse(retrievedData);
      var token = data?.token;
      let obj = {
        file_url: imgObj.imageslist[index].key,
        inspection_answer_id: imgObj.inspection_answer_id,
      };
      let request = await fetch(
        GlobalApi + "/InspectionAnswer/delete_image_multiple",
        {
          method: "Post",
          headers: new Headers({
            Authorization: "Bearer " + token,
            "Content-Type": "application/json",
          }),
          body: JSON.stringify(obj),
        }
      );
      let resJson = await request.json();
      //alert(JSON.stringify(resJson))
      if (resJson.status === "Success") {
        await getFileSize();
        await getInspection();
        setSpinner(false);
        swal(t("Success"), t("Inspection has been updated"), "success");
      }
    }
  }

  console.log("answersOOOO", inspection);
  if (template.length === 0) {
    return <Spinner />;
  } else {
    return <div style={{ padding: 20, backgroundColor: Colors.globalColor9, height: "100vh", overflowY: "scroll", overflowX: "hidden" }}>
        <ModalSpinner show={showSpinner} />
        <Grid container spacing={3} direction="row">
          <Grid item xs={12}>
            <Grid container spacing={3} direction="row">
              <Grid item xs={12} sm={12} md={3}>
                <Paper variant="outlined" style={{ padding: 10, textAlign:'center' }}>
                  <p className="label2" style={{ marginBottom: 10,textAlign:'center', fontSize: 16, marginTop: 5,  marginBottom: 5, color: Colors.globalColor8, textTransform: "uppercase" }}>
                    {inspection ? inspection?.Schedule?.title : ""}
                  </p>

                  <Grid container spacing={3} direction="row">
                    <Grid item xs={12} md={6} style={{borderRight:window.innerWidth > 700 && '1px solid #dadada'}}>
                      <p className="label2" style={{ marginBottom: 5, fontSize: 12, marginTop: 0, textAlign: "center", fontWeight:'bold' }}>
                        {t("Total Score")}
                      </p>
                      <p className="label2" style={{ marginBottom: 0, fontSize: 14, marginTop: 0, textAlign: "center",fontWeight:'normal' }}>
                        {totalScore} %
                      </p>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <p className="label2" style={{ marginBottom: 5, fontSize: 12, textAlign: "center", marginTop: 0, color: Colors.globalColor8 }}>
                        {t("Total Actions")}
                      </p>
                      <p className="label2" style={{ marginBottom: 0, fontSize: 14, marginTop: 0, textAlign: "center",fontWeight:'normal' }}>
                        {totalActions}
                      </p>
                    </Grid>
                  </Grid>
                  <br/>
                  {width >= 960 ? template.map((temp, tempIndex) => {
                      console.log("temp>>>>>>>>>>>", temp);
                      // let score_nag = temp.checklist.list.filter((v) => {
                      //   // console.log(answers[v.id]?.value, answers[v.id])
                      //   if (
                      //     answers[v.id]?.value === null ||
                      //     answers[v.id]?.value === "" ||
                      //     answers[v.id]?.value === undefined ||
                      //     answers[v.id]?.value === "[]" ||
                      //     answers[v.id]?.value?.length === 0
                      //   ) {
                      //     return answers[v.id];
                      //   }
                      // });
                      return <Paper variant="outlined" className="pointer-cursor" style={{ padding: 10, margin: 2, backgroundColor: globalIndex === tempIndex ? Colors.globalColor9 : Colors.backgroundColor }} onClick={() => setGlobalIndex(tempIndex)} square>
                          <Grid container // spacing={2}
                            direction="row" justify="space-between" alignItems="center">
                            <Grid item xs={7}>
                              <p className="templateName" style={{ margin: 0, fontSize: 14 }}>
                                {temp.title.slice(0, 25) + (temp.title.length > 25 ? "..." : "")}
                              </p>

                            </Grid>
                            <Grid item xs={5} align={language =="ar" ? "left" : "right"}>
                              <div style={{ height: 60, width: 60, marginTop: 10,textAlign:language =="ar" ? "left" : "right" }}>
                                {temp.loading ? <CircularProgress /> : <CircularProgressWithLabel value={!temp.score ? 0 : parseInt(temp.score).toFixed()} />}

                                {/* // <CircularProgressWithLabel value={!temp.score ? 0 : parseInt(temp.score).toFixed()} /> */}
                                  
                              </div>
                            </Grid>
                          </Grid>
                        </Paper>;
                    }) : <FormControl variant="outlined" fullWidth>
                      <Select labelId="demo-simple-select-outlined-label" id="demo-simple-select-outlined" value={globalIndex} onChange={(e, tempIndex) => setGlobalIndex(e.target.value)} fullWidth>
                        {template.map((temp, tempIndex) => {
                          console.log("MMMMMMM", temp);
                          return <MenuItem value={tempIndex}>
                              <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                                <div>
                                  {" "}
                                  <p className="templateName" style={{ margin: 0, fontSize: 14 }}>
                                    {temp.title.slice(0, 25) + (temp.title.length > 25 ? "..." : "")}
                                  </p>
                                </div>
                                <div>
                                  <p className="templateName" style={{ margin: 0, fontSize: 14 }}>
                                    {" "}
                                    {temp.score}%{" "}
                                  </p>{" "}
                                </div>
                              </div>
                            </MenuItem>;
                        })}
                      </Select>
                    </FormControl>}

                  {isReview !== "edit" && <Paper variant="outlined" className="pointer-cursor" style={{ padding: 10, margin: 2, backgroundColor: globalIndex === template.length ? Colors.globalColor9 : Colors.backgroundColor }} onClick={() => setGlobalIndex(template.length)} square>
                      <Grid container // spacing={2}
                        direction="row" justify="space-between" alignItems="center">
                        <Grid item xs={12}>
                          <Typography style={{ color: "black", marginTop: 10, marginBottom: 10 }}>
                            {t("Reviews / Comments")}
                          </Typography>
                        </Grid>
                        <Grid item xs={5} align="right" />
                      </Grid>
                    </Paper>}
                </Paper>
              </Grid>
              <Grid item xs={12} sm={12} md={9}>
                <Grid container spacing={3} direction="row">
                  <Grid item xs={12} sm={12} style={{ textAlign: "left" }}>
                    {/* <Typography variant="h6">
                      Data Storage Limit:{" "}
                      {currentFileSize !== 0 ? currentFileSize?.toFixed(2) : 0}{" "} */}
                    {/* / {packageDetails?.file_size_per_user} MB */}
                    {/* </Typography> */}
                    <div className={classes.root} style={{}}>
                      {template.map((temp, tempIndex) => {
                        if (tempIndex === globalIndex) {
                          console.log(temp);
                          return <ExpansionPanel key={temp.id + tempIndex} expanded={true} style={{ width: "100%" }}>
                              <ExpansionPanelSummary style={{ backgroundColor: Colors.globalColor8 }}>
                                <div style={{ display: "flex", width: "100%", justifyContent: "space-between", alignItems: "center" }}>
                                  <Typography // className={classes.heading}
                                    style={{ color: "white" }} variant="h6">
                                    {temp.title}
                                  </Typography>
                                  {window.innerWidth < 960 && <Typography // className={classes.heading}
                                      style={{ color: "white" }} variant="h6">
                                      {temp.score}%
                                    </Typography>}
                                </div>
                              </ExpansionPanelSummary>
                              <ExpansionPanelDetails style={{ border: "1px solid #dadada" }}>
                                <Container disableGutters={true}>
                                  {temp?.checklist?.list.map(
                                    (che, checkIndex) => {
                                      console.log(
                                        "op",
                                        che.dataType,
                                        che.title
                                      );
                                      return (
                                        <Paper
                                          key={che.id}
                                          variant="outlined"
                                          style={{
                                            padding: 5,
                                            paddingRight:language!=="ar" && 15,
                                            paddingLeft:language=="ar" && 15,
                                            margin: 5,
                                            backgroundColor:
                                              Colors.backgroundColor,
                                            overflow: "hidden",
                                          }}
                                        >
                                          <CheckContainer
                                            che={che}
                                            answers={answers}
                                            handleChangeText={
                                              handleChangeText
                                            }
                                            handleFile={handleFile}
                                            handleChangeCustom={
                                              handleChangeCustom
                                            }
                                            handleMeta={handleMeta}
                                            inspection_id={inspection.id}
                                            inspection_answer_list={
                                              inspection.InspectionAnswers
                                            }
                                            handleCondText={handleCondText}
                                            isEditor={
                                              inspection?.created_by !==
                                                currentUser?.user_id ||
                                              (!inspection?.InspectionShares.filter(
                                                (v) =>
                                                  v.user_id ===
                                                  currentUser.user_id
                                              )[0]
                                                ? inspection?.InspectionShares.filter(
                                                    (v) =>
                                                      v.user_id ===
                                                      currentUser.user_id
                                                  )[0]?.isEditor === true
                                                : false)
                                            }
                                            package_id={
                                              packageDetails?.package?.id
                                            }
                                            handleDeleteVideo={
                                              handleDeleteVideo
                                            }
                                            handleDeleteImage={
                                              handleDeleteImage
                                            }
                                            handleDeleteMultipleImage={
                                              handleDeleteMultipleImage
                                            }
                                             getInspectionScore={getInspectionScore}
                                             isCompleted={inspection.isCompleted}
                                             pdf_url={inspection?.pdf_url}
                                            
                                          />
                                        </Paper>
                                      );
                                    }
                                  )}
                                </Container>
                              </ExpansionPanelDetails>
                            </ExpansionPanel>;
                        } else {
                          return <div />;
                        }
                      })}
                      {isReview !== "edit" && template.length === globalIndex ? <ExpansionPanel key={template.length} expanded={true} style={{ width: "100%" }}>
                          <ExpansionPanelSummary style={{ backgroundColor: Colors.globalColor9 }}>
                            <Typography // className={classes.heading}
                              style={{ color: Colors.globalColor8 }} variant="h5">
                              {t("Reviews / Comments")}
                            </Typography>
                          </ExpansionPanelSummary>

                          <ExpansionPanelDetails>
                            <Paper variant="outlined" style={{ padding: 10, backgroundColor: Colors.backgroundColor, width: "100%" }}>
                              <div style={{ textAlign: "right", padding: 5 }}>
                                {hierarchyOrganization?.position === "1" && <DarkButton style={{ margin: 5 }} onClick={() => {
                                      setBtnLoader(true);
                                     
                                      handlePdfDownload(inspection.isCompleted.toString(),inspection?.pdf_url);
                                    }} disabled={btnLoader}>
                                    {btnLoader ? "Downloading..." : " Download"}
                                  </DarkButton>}
                              </div>
                              <TextField id="outlined-multiline-static" label={t("Comment")} multiline rows={5} variant="outlined" fullWidth onChange={(e) => setComment(e.target.value)} autoComplete="off" value={comment} disabled={inspection?.InspectionComments.filter((v) => v.hierarchy_organization_id === isReview).length !== 0 || isReview == "view"} />

                              <Button style={{ margin: 5 }} color="primary" onClick={() => handleComment("Approved")} disabled={inspection?.InspectionComments.filter((v) => v.hierarchy_organization_id === isReview).length !== 0 || isReview == "view"}>
                                {t("Approve")}
                              </Button>
                              <Button style={{ margin: 5 }} color="secondary" onClick={() => handleComment("Rejected")} disabled={inspection?.InspectionComments.filter((v) => v.hierarchy_organization_id === isReview).length !== 0 || isReview == "view"}>
                                {t("Reject")}
                              </Button>
                            </Paper>
                          </ExpansionPanelDetails>
                          {inspection?.InspectionComments.map((com) => {
                            console.log(com);
                            return <ExpansionPanelDetails>
                                <Paper variant="outlined" style={{ padding: 10, backgroundColor: Colors.backgroundColor, width: "100%", display: "block" }}>
                                  <Typography variant="h4" style={{ color: com.status === "Rejected" ? "red" : "green", marginBottom: 5 }}>
                                    {com.status}
                                  </Typography>
                                  <Typography variant="h6">
                                    {com.comment}
                                  </Typography>
                                  <Typography variant="overline">
                                    {t("Review / Comment by")}: {com?.User?.first_name} {com?.User?.last_name} At {moment(com.createdAt).format("MMMM DD, YYYY")}
                                  </Typography>
                                </Paper>
                              </ExpansionPanelDetails>;
                          })}
                        </ExpansionPanel> : ""}
                    </div>
                  </Grid>
                </Grid>

                {/* +++++++++++++++++++++++++++++++++++++++++++++Section Starts- */}
                <Grid container direction="row" spacing={2} justify="space-between" alignItems="flex-start" style={{ padding: "0px 10px" }}>
                  <Grid item xs={12} sm={8} style={{ textAlign: "left" }}>
                    <Grid container spacing={2}>
                      {template.length - 1 == globalIndex && <>
                          {inspection.isCompleted !== true && <Grid item xs={12} md={4}>
                          {/* disabled={inspection?.created_by !== currentUser?.user_id || !inspection?.InspectionShares.filter((v) => v.user_id === currentUser.user_id)[0] ? inspection?.InspectionShares.filter((v) => v.user_id === currentUser.user_id)[0]?.isEditor !== true : false} */}
                              <Button variant="contained" className="addBtn" color={"primary"} style={{ backgroundColor: Colors.globalColor8, width: "100%" }} onClick={() => handleComplete()}>
                                Mark As Completed
                              </Button>
                            </Grid>}
                        </>}

                      {inspection.isCompleted !== true && <Grid item xs={6} md={2}>
                          <Button variant="contained" className="addBtn" color={"primary"} style={{ backgroundColor: Colors.globalColor8, width: "100%" }} onClick={() => (inspection && inspection.InspectionAnswers && inspection.InspectionAnswers.length !== 0 ? handleEdit(true) : handleSubmit())} disabled={inspection?.created_by !== currentUser?.user_id || !inspection?.InspectionShares.filter((v) => v.user_id === currentUser.user_id)[0] ? inspection?.InspectionShares.filter((v) => v.user_id === currentUser.user_id)[0]?.isEditor === true : false}>
                            {t("Save")}
                          </Button>
                        </Grid>}

                      <Grid item xs={6} md={2}>
                        <Button variant="contained" className="cancelBtn2" onClick={() => history.goBack()
                            // isReview !== "edit"
                            //   ? history.push("/")
                            //   : history.goBack()
                          } style={{ width: "100%" }}>
                          {t("Cancel")}
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12} sm={4} style={{ textAlign: "right" }}>
                    <Grid container spacing={2}>
                      {(globalIndex !== 0 && isReview !== "view" )&& <Grid item xs={6}>
                          <Button variant="contained" className="addBtn" color={"primary"} style={{ backgroundColor: Colors.globalColor8, width: "100%" }} onClick={() => {
                              if (inspection?.isCompleted !== true) {
                                inspection && inspection.InspectionAnswers && inspection.InspectionAnswers.length !== 0 ? handleEdit(false) : handleSubmit();
                              }
                              setGlobalIndex(globalIndex - 1);
                            }} disabled={globalIndex === 0}>
                            {t("Previous")}
                          </Button>
                        </Grid>}

                      {(template.length - 1 !== globalIndex && isReview !== "view") && <Grid item xs={6}>
                          <Button variant="contained" className="addBtn" color={"primary"} style={{ backgroundColor: Colors.globalColor8,
                              color: "white", width: "100%" }} onClick={() => {
                              if (inspection?.isCompleted !== true) {
                                inspection && inspection.InspectionAnswers && inspection.InspectionAnswers.length !== 0 ? handleEdit(false) : handleSubmit();
                              }
                              setGlobalIndex(globalIndex + 1);
                            }} disabled={isReview !== "edit" ? globalIndex === template.length : globalIndex === template.length - 1}>
                            {t("Next")}
                          </Button>
                        </Grid>}
                    </Grid>
                  </Grid>
                </Grid>

                {/* <Grid
                  container
                  spacing={3}
                  direction="row"
                  justify="center"
                  alignItems="flex-start"
                  style={{ backgroundColor: "green" }}
                >
                  {template.length - 1 !== globalIndex &&
                  inspection?.isCompleted !== true ? (
                    <Grid item xs={12} sm={6} style={{ textAlign: "left" }}>
                      {window.innerWidth > 700 ? (
                        <DarkButton
                          variant="contained"
                          // color="primary"
                          style={{ backgroundColor: Colors.globalColor8 }}
                          onClick={() =>
                            inspection &&
                            inspection.InspectionAnswers &&
                            inspection.InspectionAnswers.length !== 0
                              ? handleEdit(true)
                              : handleSubmit()
                          }
                          disabled={
                            inspection?.created_by !== currentUser?.user_id ||
                            !inspection?.InspectionShares.filter(
                              (v) => v.user_id === currentUser.user_id
                            )[0]
                              ? inspection?.InspectionShares.filter(
                                  (v) => v.user_id === currentUser.user_id
                                )[0]?.isEditor !== true
                              : false
                          }
                        >
                          Save
                        </DarkButton>
                      ) : (
                        <DarkButton
                          variant="contained"
                          // color="primary"
                          style={{
                            backgroundColor: Colors.globalColor8,
                            width: window.innerWidth <= 500 && "100%",
                          }}
                          onClick={() =>
                            inspection &&
                            inspection.InspectionAnswers &&
                            inspection.InspectionAnswers.length !== 0
                              ? handleEdit(true)
                              : handleSubmit()
                          }
                          disabled={
                            inspection?.created_by !== currentUser?.user_id ||
                            !inspection?.InspectionShares.filter(
                              (v) => v.user_id === currentUser.user_id
                            )[0]
                              ? inspection?.InspectionShares.filter(
                                  (v) => v.user_id === currentUser.user_id
                                )[0]?.isEditor !== true
                              : false
                          }
                        >
                          Save
                        </DarkButton>
                      )}
                    </Grid>
                  ) : (
                    <Grid item xs={12} sm={6} style={{ textAlign: "left" }}>
                      <Grid container>
                        <Grid item xs={12}>
                          {inspection?.isCompleted !== true && (
                            <>
                              {window.innerWidth > 700 ? (
                                <DarkButton
                                  variant="contained"
                                  style={{ marginRight: "20px" }}
                                  style={{
                                    backgroundColor: Colors.globalColor8,
                                  }}
                                  onClick={() => handleComplete()}
                                  disabled={
                                    inspection?.created_by !==
                                      currentUser?.user_id ||
                                    !inspection?.InspectionShares.filter(
                                      (v) => v.user_id === currentUser.user_id
                                    )[0]
                                      ? inspection?.InspectionShares.filter(
                                          (v) =>
                                            v.user_id === currentUser.user_id
                                        )[0]?.isEditor !== true
                                      : false
                                  }
                                >
                                  Mark As Completed
                                </DarkButton>
                              ) : (
                                <DarkButton
                                  variant="contained"
                                  style={{
                                    backgroundColor: Colors.globalColor8,
                                    marginBottom: "0px",
                                    width: "100%",
                                  }}
                                  onClick={() => handleComplete()}
                                  disabled={
                                    inspection?.created_by !==
                                      currentUser?.user_id ||
                                    !inspection?.InspectionShares.filter(
                                      (v) => v.user_id === currentUser.user_id
                                    )[0]
                                      ? inspection?.InspectionShares.filter(
                                          (v) =>
                                            v.user_id === currentUser.user_id
                                        )[0]?.isEditor !== true
                                      : false
                                  }
                                >
                                  Mark As Completed
                                </DarkButton>
                              )}
                              &emsp;
                            </>
                          )}
                        </Grid>

                        {inspection.isCompleted !== true && (
                          <Grid item xs={12}>
                            <DarkButton
                              variant="contained"
                              // color="primary"
                              style={{ marginLeft: 10 }}
                              style={{
                                backgroundColor: Colors.globalColor8,
                                width: window.innerWidth <= 500 && "100%",
                              }}
                              onClick={() =>
                                inspection &&
                                inspection.InspectionAnswers &&
                                inspection.InspectionAnswers.length !== 0
                                  ? handleEdit(true)
                                  : handleSubmit()
                              }
                              disabled={
                                inspection?.created_by !==
                                  currentUser?.user_id ||
                                !inspection?.InspectionShares.filter(
                                  (v) => v.user_id === currentUser.user_id
                                )[0]
                                  ? inspection?.InspectionShares.filter(
                                      (v) => v.user_id === currentUser.user_id
                                    )[0]?.isEditor === true
                                  : false
                              }
                            >
                              Save
                            </DarkButton>
                          </Grid>
                        )}
                      </Grid>

                      <Button
                        variant="contained"
                        className="cancelBtn"
                        onClick={
                          () => history.goBack()
                          // isReview !== "edit"
                          //   ? history.push("/")
                          //   : history.goBack()
                        }
                        style={{
                          marginTop: window.innerWidth < 500 && 10,
                          marginLeft: window.innerWidth < 500 && 0,
                          width: window.innerWidth < 500 && "100%",
                        }}
                      >
                        Cancel
                      </Button>
                    </Grid>
                  )}
                  <Grid item xs={12} sm={6} style={{ textAlign: "right" }}>
                    <Grid container>
                      <Grid item xs={6}>
                        <DarkButton
                          variant="contained"
                          style={{
                            backgroundColor: Colors.globalColor8,
                            width: "100%",
                          }}
                          onClick={() => {
                            if (inspection?.isCompleted !== true) {
                              inspection &&
                              inspection.InspectionAnswers &&
                              inspection.InspectionAnswers.length !== 0
                                ? handleEdit(false)
                                : handleSubmit();
                            }
                            setGlobalIndex(globalIndex - 1);
                          }}
                          disabled={globalIndex === 0}
                        >
                          Previous
                        </DarkButton>
                      </Grid>
                      <Grid item xs={6}>
                        <DarkButton
                          variant="contained"
                          style={{
                            backgroundColor: Colors.globalColor8,
                            marginLeft: 5,
                            color: "white",
                            width: "100%",
                          }}
                          onClick={() => {
                            if (inspection?.isCompleted !== true) {
                              inspection &&
                              inspection.InspectionAnswers &&
                              inspection.InspectionAnswers.length !== 0
                                ? handleEdit(false)
                                : handleSubmit();
                            }
                            setGlobalIndex(globalIndex + 1);
                          }}
                          disabled={
                            isReview !== "edit"
                              ? globalIndex === template.length
                              : globalIndex === template.length - 1
                          }
                        >
                          Next
                        </DarkButton>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid> */}
                {/* +++++++++++++++++++++++++++++++++++++++++++++Section Ends  */}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <br />
        <br />
      </div>;
  }
}

let TextInputFeild = ({
  value,
  name,
  onChange,
  multiline = false,
  type = "text",
}) => {
  return (
    <TextField
      style={{ margin: 5 }}
      label={name}
      // type={"text"}
      fullWidth
      multiline={multiline}
      rows={4}
      type={type}
      autoComplete="off"
      name={name}
      variant="outlined"
      id="outlined-basic"
      value={value}
      onChange={onChange}
    />
  );
};

let DateTimeField = ({ value, name, onChange }) => {
  if (value === "") {
    onChange(new Date());
  }
  return (
    <KeyboardDateTimePicker
      fullWidth
      style={{ margin: 5 }}
      inputVariant="outlined"
      id="outlined-basic"
      value={value}
      name={name}
      onChange={onChange}
      label={name}
      autoComplete="off"
      // views={}
      format={"MMMM dd yyyy, h:mm"}
      autoFocus
    />
  );
};

let CheckBoxField = ({ value, name, onChange }) => {
  console.log(value, "checkbox");
  return (
    <FormControlLabel
      control={
        <Checkbox checked={value !== null && value !== undefined } onChange={onChange} name={name} />
      }
      label={name}
    />
  );
};

let SliderField = ({ value, name, onChange }) => {
  return (
    <Container>
      <Typography id="discrete-slider" gutterBottom>
        {name}
      </Typography>

      <Slider
        value={value}
        onChange={(e, value) => onChange(value)}
        name={name}
        style={{ marginLeft: "10%" }}
        min={0}
        max={10}
      />
      <Typography
        id="discrete-slider"
        variant="h6"
        gutterBottom
        style={{ textAlign: "center" }}
      >
        value: {value ? value : 0}
      </Typography>
    </Container>
  );
};

let CustomField = ({ value, name, onChange, customFields, isMultiple }) => {
  return (
    <>
      {/* <Grid container style={{ width: "100%" }} spacing={0}> */}
      {/* <Grid item xs={12} align="flex-start" justify="flex-start">
          <Typography
            variant="overline"
            style={{
              marginLeft: 5,
              textAlign: "left",
            }}
          >
            {name}
          </Typography>
        </Grid> */}
      {/* </Grid> */}
      <Grid
        container
        align="center"
        justify="center"
        direction="row"
        style={{ width: "100%" }}
        spacing={0}
      >
        <Grid item>
          {customFields.responses
            .sort((a, b) => a.position - b.position)
            .map((v, i) => {
              console.log("Custom", v, value.indexOf(v) !== -1, value);
              return (
                <Button
                  variant="outlined"
                  key={v.id + i}
                  style={{
                    margin: 5,
                    minWidth: 100,
                    backgroundColor:
                      value.indexOf(v) !== -1
                        ? Colors.globalColor8
                        : Colors.backgroundColor,
                    color:
                      value.indexOf(v) == -1
                        ? Colors.globalColor8
                        : Colors.backgroundColor,
                  }}
                  onClick={() => onChange(v)}
                >
                  {isMultiple == true && (
                    <Checkbox
                      checked={value.indexOf(v) !== -1 ? true : false}
                      style={{ padding: 0, marginRight: 5 }}
                      color={value.indexOf(v) !== -1 ? "primary" : "secondary"}
                    />
                  )}
                  {v.title}
                </Button>
              );
            })}{" "}
        </Grid>
      </Grid>
    </>
  );
};

let AnnotationField = ({ value, name, onChange, onDelete, isCompleted }) => {
  console.log("annotation", Colors.fileUrl + value);
  return (
    <Grid constainer spacing={2} align="center" justify="center">
      <Grid item xs={12} style={{ maxWidth: "250px" }}>
        {value !== "" && (
          <ModalImage
            hideDownload
            hideZoom
            width="200px"
            small={
              !value?.name ? Colors.fileUrl + value : URL.createObjectURL(value)
            }
            large={
              !value?.name ? Colors.fileUrl + value : URL.createObjectURL(value)
            }
            alt=""
          />
        )}
      </Grid>
      {isCompleted == true ? <Grid item xs={12}>
        {value !== "" && value !== null ? (
          <Button
            variant="contained"
            className="addBtn2"
            color={"primary"}
            // fullWidth
            component="label"
            disabled
            style={{ backgroundColor: Colors.globalColor8 }}
          >
            Delete Annotation
          </Button>
        ) : (
          <Button
            variant="contained"
            className="addBtn"
            color={"primary"}
            // fullWidth
            component="label"
            disabled
            style={{ backgroundColor: Colors.globalColor8 }}
          >
            Add Annotation
          </Button>
        )}
      </Grid> : <Grid item xs={12}>
        {value !== "" && value !== null ? (
          <Button
            variant="contained"
            className="addBtn"
            color={"primary"}
            // fullWidth
            component="label"
            style={{ backgroundColor: Colors.globalColor8 }}
            onClick={() => onDelete()}
          >
            Delete Annotation
          </Button>
        ) : (
          <Button
            variant="contained"
            className="addBtn"
            color={"primary"}
            // fullWidth
            component="label"
            style={{ backgroundColor: Colors.globalColor8 }}
          >
            Add Annotation
            <input
              type="file"
              accept="image/*"
              style={{ display: "none" }}
              onChange={onChange}
            />
          </Button>
        )}
      </Grid>}
    </Grid>
  );
};

let PhotoField = ({ value, name, onChange, onDelete, isCompleted }) => {
  const {t} = useTranslation();
  console.log("customFields", value);
  return (
    <Grid constainer spacing={2} align="center" justify="center">
      <Grid item xs={12} style={{ maxWidth: "250px" }}>
        {value !== "" && (
          <ModalImage
            hideDownload
            hideZoom
            small={
              !value?.name ? Colors.fileUrl + value : URL.createObjectURL(value)
            }
            large={
              !value?.name ? Colors.fileUrl + value : URL.createObjectURL(value)
            }
            alt=""
          />
        )}
      </Grid>
      {isCompleted == true ? <Grid item xs={12}>
        {value !== "" && value !== null ? (
          <Button
            variant="contained"
            className="addBtn2"
            disabaled
            color={"primary"}
            // fullWidth
            component="label"
            style={{ backgroundColor: "#dadada" }}
          >
            {t("Delete Photo")}
          </Button>
        ) : (
          <Button
            variant="contained"
            className="addBtn2"
            color={"primary"}
            disabled
            component="label"
            style={{ backgroundColor: "#dadada" }}
          >
            {t("Add Photo")}
          </Button>
        )}
      </Grid> : <Grid item xs={12}>
        {value !== "" && value !== null ? (
          <Button
            variant="contained"
            className="addBtn"
            color={"primary"}
            // fullWidth
            component="label"
            style={{ backgroundColor: Colors.globalColor8 }}
            onClick={() => onDelete()}
          >
            Delete Photo
          </Button>
        ) : (
          <Button
            variant="contained"
            className="addBtn"
            color={"primary"}
            // fullWidth
            component="label"
            style={{ backgroundColor: Colors.globalColor8 }}
          >
            Add Photo
            <input
              type="file"
              accept="image/*"
              style={{ display: "none" }}
              onChange={onChange}
            />
          </Button>
        )}
      </Grid>}
    </Grid>
  );
};

let SignatureField = ({
  valueText,
  valueImage,
  name,
  onChangeText,
  onChangeFile,
  onDelete,
  isCompleted
}) => {
  // console.log(customFields, value);
  return (
    <Grid constainer spacing={2} align="center" justify="center">
      <Grid item xs={12} style={{ maxWidth: "250px" }}>
        {valueImage !== "" && (
          <ModalImage
            hideDownload
            hideZoom
            small={
              !valueImage?.name
                ? Colors.fileUrl + valueImage
                : URL.createObjectURL(valueImage)
            }
            large={
              !valueImage?.name
                ? Colors.fileUrl + valueImage
                : URL.createObjectURL(valueImage)
            }
            width="200px"
            alt={""}
          />
        )}
      </Grid>

      {/* <Grid item xs={12}>
        <TextField
          style={{ margin: 5 }}
          label={name}
          type={"text"}
          fullWidth
          rows={4}
          autoComplete="off"
          name={name}
          variant="outlined"
          id="outlined-basic"
          value={valueText}
          onChange={onChangeText}
        />
      </Grid> */}

     {isCompleted == true ?  <Grid item xs={12} align="center" justify="center">
        {valueImage !== "" && valueImage !== null ? (
          <Button
            variant="contained"
            className="addBtn2"
            color={"primary"}
            // fullWidth
            component="label"
            style={{ backgroundColor: Colors.globalColor8 }}
          
          >
            Delete Signature
          </Button>
        ) : (
          <Button
            variant="contained"
            className="addBtn2"
            color={"primary"}
            // fullWidth
            component="label"
            disabled
            style={{ backgroundColor: Colors.globalColor8 }}
          >
            Add Signature
        
          </Button>
        )}
      </Grid> :  <Grid item xs={12} align="center" justify="center">
        {valueImage !== "" && valueImage !== null ? (
          <Button
            variant="contained"
            className="addBtn"
            color={"primary"}
            // fullWidth
            component="label"
            style={{ backgroundColor: Colors.globalColor8 }}
            onClick={() => onDelete()}
          >
            Delete Signature
          </Button>
        ) : (
          <Button
            variant="contained"
            className="addBtn"
            color={"primary"}
            // fullWidth
            component="label"
            style={{ backgroundColor: Colors.globalColor8 }}
          >
            Add Signature
            <input
              type="file"
              accept="image/*"
              style={{ display: "none" }}
              onChange={onChangeFile}
            />
          </Button>
        )}
      </Grid>}
    </Grid>
  );
};

function CircularProgressWithLabel(props) {
  return (
    <CircularProgressbar
      className="monthly-circle"
      text={`${props.value}%`}
      value={props.value}
      styles={buildStyles({
        // Text size
        textSize: "18px",
        textColor: props.isSelected ? Colors.globalColor8 : "#0a66c2",
        // textAlign: "center",
        // // Colors
        pathColor: props.value < 25 ? "red" : (props.value > 25 && props.value < 75 ) ? "blue" :'green',
        trailColor: !props.isSelected ? "#d6d6d6" : Colors.globalColor8,
        // textColor: '#f88',
        // backgroundColor: '#3e98c7',
      })}
      // circleRatio={.5}
      color={props.isSelected ? "secondary" : "primary"}
    />
  );
}

function CheckContainer({
  che,
  answers,
  handleChangeText,
  handleFile,
  handleChangeCustom,
  handleMeta,
  inspection_id,
  handleCondText,
  inspection_answer_list = [],
  isConditional = false,
  isEditor,
  package_id,
  handleDeleteVideo,
  handleDeleteImage,
  handleDeleteMultipleImage,
  getInspectionScore,
  isCompleted,
}) {
  let {t} = useTranslation();
  const language = useSelector((state) => state.languageReducer.language);
  let [note, setNote] = React.useState(
    answers[che.id] !== undefined ? answers[che.id].note : null
  );

  console.log("chechechechecheche",che)

  let action_filter = _.filter(inspection_answer_list, function(u) {
    if (u.check_id === che.id && u.Actions.length !== 0) return u;
  })[0];

  const [actionList, setActionList] = React.useState(
    action_filter !== undefined
      ? action_filter.Actions.filter((v) => v.isDeleted == false)
      : []
  );

  const [action, setAction] = React.useState(false);
  const [actionField, setActionField] = React.useState(false);
  const [actionFieldInput, setActionFieldInput] = React.useState("");
  const [actionFieldDescription, setActionFieldDescription] = React.useState("");
  let company = useSelector((state) => state.companyReducer.company);



  // console.log(package_id);

  const toggleAction = (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setAction(!action);
  
  };

  function createAction() {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;

    console.log(
      "CREATE ACTION API _______________________________________________"
    );
    fetch(GlobalApi + "/Action/create_action", {
      method: "post",
      headers: new Headers({
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify({
        title: actionFieldInput,
        description: actionFieldDescription,
        created_by: data.user_id,
        inspection_id,
        inspection_answer_id: answers[che.id].inspection_answer_id,
        company_id: company.id,
        identifier: "InspectionAnswers",
      }),
    })
      .then((response) => response.json())
      .then(async (res) => {
        if (res.status === "Success") {
          let arr = [...actionList, res.data];
          setActionList(arr);
          setActionField(false);
          setActionFieldInput("");
        }else if(res.status === "Error"){
          swal(t("Error"),res.err,"error");
        } else if (
          res.error === "jwt expired" ||
          res.error === "invalid token" ||
          res.error === "invalid signature" ||
          res.error === "Unexpected token"
        ) {
          let status = await refresh_token();
          if (status) {
            createAction();
          }
        }
      })
      .catch((err) => {
        console.log(err, "error");
      });
  }

  async function handleDelete(id) {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;


    swal({
      title: "Are you sure?",
      text: t("All Data Including Media will be permenantly Deleted!"),
      icon: "warning",
      buttons: [t("No, cancel it!"), t("Yes, I am sure!")],
      dangerMode: true,
    }).then(async function(isConfirm) {
      if (isConfirm) {
        try {
          let res = await fetch(GlobalApi + "/Action/edit_action", {
            method: "post",
            headers: new Headers({
              Authorization: "Bearer " + token,
              "Content-Type": "application/json",
            }),
            body: JSON.stringify({
              company_id: company.id,
              action_id: id,
              ["isDeleted"]: true,
            }),
          });
      
          let resJson = await res.json();
      
          let action_list = actionList;
      
          let filter = action_list.filter((c) => c.id !== id);
          setActionList(filter);
          // getInspectionScore()
          setAction(false);
          console.log(resJson.data);
        } catch (err) {
          console.log(err);
        }
      } else {
        console.log("Canceled");
      }
    });
    
 
  }

  console.log("CHECHEHCEHCHECHE",che)
  return <Grid container spacing={0}>
      <Grid item xs={12} style={{ textAlign: language == "ar" ? "right" : "left" }}>
        {che.dataType !== "Checkbox" && <>
            <Typography variant="p" style={{ marginRight: language == "ar" && "10px", marginLeft: language !== "ar" && "10px" }}>
              {che.title}
            </Typography>

            {che.mandatory && che.dataType !== "Signature" && che.dataType !== "Instruction" && !che.parent && <Typography variant="p" style={{ color: "red", fontWeight: "bold" }}>
                *
              </Typography>}
          </>}


        {che.dataType === "Text field" && <>
            <TextInputFeild value={answers[che.id] !== undefined ? answers[che.id].value : ""} // name={che.title}
              onChange={(e) => handleChangeText(e.target.value, che.id)} />

            {che.conditional === "yes" && che.conditionValue.toLowerCase() == answers[che.id]?.value?.toLowerCase() && che.condition == "is" && che?.conditionalList.map(
                (v) => {
                  return (
                    <CheckContainer
                      che={v}
                      answers={answers}
                      handleChangeText={handleChangeText}
                      handleFile={handleFile}
                      handleChangeCustom={handleChangeCustom}
                      handleMeta={handleMeta}
                      handleCondText={handleCondText}
                      isConditional={true}
                      getInspectionScore={getInspectionScore}
                      isCompleted={isCompleted}
                    />
                  );
                }
              )}

            {che.conditional === "yes" && che.conditionValue.toLowerCase() != answers[che.id]?.value?.toLowerCase() && che.condition == "is not" && che?.conditionalList.map(
                (v) => {
                  return (
                    <CheckContainer
                      che={v}
                      answers={answers}
                      handleChangeText={handleChangeText}
                      handleFile={handleFile}
                      handleChangeCustom={handleChangeCustom}
                      handleMeta={handleMeta}
                      isConditional={true}
                      handleCondText={handleCondText}
                      getInspectionScore={getInspectionScore}
                      isCompleted={isCompleted}
                    />
                  );
                }
              )}

              {che.is_subquestion === "yes" && che?.subQuestionList.map(
                (v) => {
                  return (
                    <CheckContainer
                      che={v}
                      answers={answers}
                      handleChangeText={handleChangeText}
                      handleFile={handleFile}
                      handleChangeCustom={handleChangeCustom}
                      handleMeta={handleMeta}
                      isConditional={true}
                      handleCondText={handleCondText}
                      getInspectionScore={getInspectionScore}
                      isCompleted={isCompleted}
                    />
                  );
                }
              )}
          </>}


        {che.dataType === "Location" && <><TextInputFeild value={answers[che.id] !== undefined ? answers[che.id].value : ""} // name={che.title}
            onChange={(e) => handleChangeText(e.target.value, che.id)} multiline={true} />
            
            {che.is_subquestion === "yes" && che?.subQuestionList.map(
                (v) => {
                  return (
                    <CheckContainer
                      che={v}
                      answers={answers}
                      handleChangeText={handleChangeText}
                      handleFile={handleFile}
                      handleChangeCustom={handleChangeCustom}
                      handleMeta={handleMeta}
                      isConditional={true}
                      handleCondText={handleCondText}
                      getInspectionScore={getInspectionScore}
                      isCompleted={isCompleted}
                    />
                  );
                }
              )}
              </>}

        {che.dataType === "Number" && <>
            <TextInputFeild value={answers[che.id] !== undefined ? answers[che.id].value : ""} // name={che.title}
              onChange={(e) => handleChangeText(e.target.value, che.id)} type={"number"} />

            {che.conditional === "yes" && che.condition === "less than" && answers[che.id]?.value < parseInt(che.conditionValue) && che?.conditionalList.map(
                (v) => {
                  return (
                    <CheckContainer
                      che={v}
                      answers={answers}
                      handleChangeText={handleChangeText}
                      handleFile={handleFile}
                      handleChangeCustom={handleChangeCustom}
                      handleMeta={handleMeta}
                      isConditional={true}
                      handleCondText={handleCondText}
                      getInspectionScore={getInspectionScore}
                      isCompleted={isCompleted}
                    />
                  );
                }
              )}

            {che.conditional === "yes" && che.condition === "less than or equal to" && answers[che.id]?.value <= parseInt(che.conditionValue) && che?.conditionalList.map(
                (v) => {
                  return (
                    <CheckContainer
                      che={v}
                      answers={answers}
                      handleChangeText={handleChangeText}
                      handleFile={handleFile}
                      handleChangeCustom={handleChangeCustom}
                      handleMeta={handleMeta}
                      isConditional={true}
                      handleCondText={handleCondText}
                      getInspectionScore={getInspectionScore}
                      isCompleted={isCompleted}
                    />
                  );
                }
              )}
            {che.conditional === "yes" && che.condition === "equal to" && answers[che.id]?.value == parseInt(che.conditionValue) && che?.conditionalList.map(
                (v) => {
                  return (
                    <CheckContainer
                      che={v}
                      answers={answers}
                      handleChangeText={handleChangeText}
                      handleFile={handleFile}
                      handleChangeCustom={handleChangeCustom}
                      handleMeta={handleMeta}
                      isConditional={true}
                      handleCondText={handleCondText}
                      getInspectionScore={getInspectionScore}
                      isCompleted={isCompleted}
                    />
                  );
                }
              )}
            {che.conditional === "yes" && che.condition === "not equal to" && answers[che.id]?.value !== parseInt(che.conditionValue) && che?.conditionalList.map(
                (v) => {
                  return (
                    <CheckContainer
                      che={v}
                      answers={answers}
                      handleChangeText={handleChangeText}
                      handleFile={handleFile}
                      handleChangeCustom={handleChangeCustom}
                      handleMeta={handleMeta}
                      isConditional={true}
                      handleCondText={handleCondText}
                      getInspectionScore={getInspectionScore}
                      isCompleted={isCompleted}
                    />
                  );
                }
              )}

            {che.conditional === "yes" && che.condition === "greater than or equal to" && answers[che.id]?.value >= parseInt(che.conditionValue) && che?.conditionalList.map(
                (v) => {
                  return (
                    <CheckContainer
                      che={v}
                      answers={answers}
                      handleChangeText={handleChangeText}
                      handleFile={handleFile}
                      handleChangeCustom={handleChangeCustom}
                      handleMeta={handleMeta}
                      isConditional={true}
                      handleCondText={handleCondText}
                      getInspectionScore={getInspectionScore}
                      isCompleted={isCompleted}
                    />
                  );
                }
              )}

            {che.conditional === "yes" && che.condition === "greater than" && answers[che.id]?.value > parseInt(che.conditionValue) && che?.conditionalList.map(
                (v) => {
                  return (
                    <CheckContainer
                      che={v}
                      answers={answers}
                      handleChangeText={handleChangeText}
                      handleFile={handleFile}
                      handleChangeCustom={handleChangeCustom}
                      handleMeta={handleMeta}
                      isConditional={true}
                      handleCondText={handleCondText}
                      getInspectionScore={getInspectionScore}
                      isCompleted={isCompleted}
                    />
                  );
                }
              )}

               {che.is_subquestion === "yes" && che?.subQuestionList.map(
                (v) => {
                  return (
                    <CheckContainer
                      che={v}
                      answers={answers}
                      handleChangeText={handleChangeText}
                      handleFile={handleFile}
                      handleChangeCustom={handleChangeCustom}
                      handleMeta={handleMeta}
                      isConditional={true}
                      handleCondText={handleCondText}
                      getInspectionScore={getInspectionScore}
                      isCompleted={isCompleted}
                    />
                  );
                }
              )}
          </>}

        {che.dataType === "DateTime" && <><DateTimeField value={answers[che.id] !== undefined ? answers[che.id].value : ""} // name={che.title}
            onChange={(e) => handleChangeText(e, che.id)} />
             {che.is_subquestion === "yes" && che?.subQuestionList.map(
                (v) => {
                  return (
                    <CheckContainer
                      che={v}
                      answers={answers}
                      handleChangeText={handleChangeText}
                      handleFile={handleFile}
                      handleChangeCustom={handleChangeCustom}
                      handleMeta={handleMeta}
                      isConditional={true}
                      handleCondText={handleCondText}
                      getInspectionScore={getInspectionScore}
                      isCompleted={isCompleted}
                    />
                  );
                }
              )}

            </>}


        {che.dataType === "Checkbox" && <>
            <CheckBoxField value={answers[che.id] !== undefined ? answers[che.id].value : ""} name={che.title} onChange={(e) => handleChangeText(answers[che.id].value === "true" ? null : true, che.id)} />

            {che.conditional === "yes" && che.conditionValue === "checked" && answers[che.id]?.value == "true" && che?.conditionalList.map(
                (v) => {
                  return (
                    <CheckContainer
                      che={v}
                      answers={answers}
                      handleChangeText={handleChangeText}
                      handleFile={handleFile}
                      handleChangeCustom={handleChangeCustom}
                      handleMeta={handleMeta}
                      isConditional={true}
                      handleCondText={handleCondText}
                      getInspectionScore={getInspectionScore}
                      isCompleted={isCompleted}
                    />
                  );
                }
              )}
            {che.conditional === "yes" && che.conditionValue === "not checked" && answers[che.id]?.value == "false" && che?.conditionalList.map(
                (v) => {
                  return (
                    <CheckContainer
                      che={v}
                      answers={answers}
                      handleChangeText={handleChangeText}
                      handleFile={handleFile}
                      handleChangeCustom={handleChangeCustom}
                      handleMeta={handleMeta}
                      isConditional={true}
                      handleCondText={handleCondText}
                      getInspectionScore={getInspectionScore}
                      isCompleted={isCompleted}
                    />
                  );
                }
              )}

               {che.is_subquestion === "yes" && che?.subQuestionList.map(
                (v) => {
                  return (
                    <CheckContainer
                      che={v}
                      answers={answers}
                      handleChangeText={handleChangeText}
                      handleFile={handleFile}
                      handleChangeCustom={handleChangeCustom}
                      handleMeta={handleMeta}
                      isConditional={true}
                      handleCondText={handleCondText}
                      getInspectionScore={getInspectionScore}
                      isCompleted={isCompleted}
                    />
                  );
                }
              )}
          </>}

        {che.dataType === "Anotation" && <><AnnotationField onDelete={() => handleDeleteImage(che.id, "value")} onChange={(e) => handleFile(e.target.files[0], che.id)} value={answers[che.id] !== undefined ? answers[che.id].value : ""} isCompleted={isCompleted} />
        {che.is_subquestion === "yes" && che?.subQuestionList.map(
                (v) => {
                  return (
                    <CheckContainer
                      che={v}
                      answers={answers}
                      handleChangeText={handleChangeText}
                      handleFile={handleFile}
                      handleChangeCustom={handleChangeCustom}
                      handleMeta={handleMeta}
                      isConditional={true}
                      handleCondText={handleCondText}
                      getInspectionScore={getInspectionScore}
                      isCompleted={isCompleted}
                    />
                  );
                }
              )}</>}

        {che.dataType === "Slider" && <>
            <SliderField onChange={(e) => handleChangeText(e, che.id)} value={answers[che.id] !== undefined ? parseInt(answers[che.id].value) : 0} />

            {che.conditional === "yes" && che.condition === "less than" && answers[che.id]?.value < parseInt(che.conditionValue) && che?.conditionalList.map(
                (v) => {
                  return (
                    <CheckContainer
                      che={v}
                      answers={answers}
                      handleChangeText={handleChangeText}
                      handleFile={handleFile}
                      handleChangeCustom={handleChangeCustom}
                      handleMeta={handleMeta}
                      isConditional={true}
                      handleCondText={handleCondText}
                      getInspectionScore={getInspectionScore}
                      isCompleted={isCompleted}
                    />
                  );
                }
              )}

            {che.conditional === "yes" && che.condition === "less than or equal to" && answers[che.id]?.value <= parseInt(che.conditionValue) && che?.conditionalList.map(
                (v) => {
                  return (
                    <CheckContainer
                      che={v}
                      answers={answers}
                      handleChangeText={handleChangeText}
                      handleFile={handleFile}
                      handleChangeCustom={handleChangeCustom}
                      handleMeta={handleMeta}
                      isConditional={true}
                      handleCondText={handleCondText}
                      getInspectionScore={getInspectionScore}
                      isCompleted={isCompleted}
                    />
                  );
                }
              )}
            {che.conditional === "yes" && che.condition === "equal to" && answers[che.id]?.value == parseInt(che.conditionValue) && che?.conditionalList.map(
                (v) => {
                  return (
                    <CheckContainer
                      che={v}
                      answers={answers}
                      handleChangeText={handleChangeText}
                      handleFile={handleFile}
                      handleChangeCustom={handleChangeCustom}
                      handleMeta={handleMeta}
                      isConditional={true}
                      handleCondText={handleCondText}
                      getInspectionScore={getInspectionScore}
                      isCompleted={isCompleted}
                    />
                  );
                }
              )}
            {che.conditional === "yes" && che.condition === "not equal to" && answers[che.id]?.value !== parseInt(che.conditionValue) && che?.conditionalList.map(
                (v) => {
                  return (
                    <CheckContainer
                      che={v}
                      answers={answers}
                      handleChangeText={handleChangeText}
                      handleFile={handleFile}
                      handleChangeCustom={handleChangeCustom}
                      handleMeta={handleMeta}
                      isConditional={true}
                      handleCondText={handleCondText}
                      getInspectionScore={getInspectionScore}
                      isCompleted={isCompleted}
                    />
                  );
                }
              )}

            {che.conditional === "yes" && che.condition === "greater than or equal to" && answers[che.id]?.value >= parseInt(che.conditionValue) && che?.conditionalList.map(
                (v) => {
                  return (
                    <CheckContainer
                      che={v}
                      answers={answers}
                      handleChangeText={handleChangeText}
                      handleFile={handleFile}
                      handleChangeCustom={handleChangeCustom}
                      handleMeta={handleMeta}
                      isConditional={true}
                      handleCondText={handleCondText}
                      getInspectionScore={getInspectionScore}
                      isCompleted={isCompleted}
                    />
                  );
                }
              )}

            {che.conditional === "yes" && che.condition === "greater than" && answers[che.id]?.value > parseInt(che.conditionValue) && che?.conditionalList.map(
                (v) => {
                  return (
                    <CheckContainer
                      che={v}
                      answers={answers}
                      handleChangeText={handleChangeText}
                      handleFile={handleFile}
                      handleChangeCustom={handleChangeCustom}
                      handleMeta={handleMeta}
                      isConditional={true}
                      handleCondText={handleCondText}
                      getInspectionScore={getInspectionScore}
                      isCompleted={isCompleted}
                    />
                  );
                }
              )}

               {che.is_subquestion === "yes" && che?.subQuestionList.map(
                (v) => {
                  return (
                    <CheckContainer
                      che={v}
                      answers={answers}
                      handleChangeText={handleChangeText}
                      handleFile={handleFile}
                      handleChangeCustom={handleChangeCustom}
                      handleMeta={handleMeta}
                      isConditional={true}
                      handleCondText={handleCondText}
                      getInspectionScore={getInspectionScore}
                      isCompleted={isCompleted}
                    />
                  );
                }
              )}
          </>}

        {che.dataType === "Photo" && <><PhotoField onDelete={() => handleDeleteImage(che.id, "value")} onChange={(e) => handleFile(e.target.files[0], che.id)} value={answers[che.id] !== undefined ? answers[che.id].value : ""} isCompleted={isCompleted} />
        {che.is_subquestion === "yes" && che?.subQuestionList.map(
                (v) => {
                  return (
                    <CheckContainer
                      che={v}
                      answers={answers}
                      handleChangeText={handleChangeText}
                      handleFile={handleFile}
                      handleChangeCustom={handleChangeCustom}
                      handleMeta={handleMeta}
                      isConditional={true}
                      handleCondText={handleCondText}
                      getInspectionScore={getInspectionScore}
                      isCompleted={isCompleted}
                    />
                  );
                }
              )}
              </>}

        {che.dataType === "Signature" && <>
            <SignatureField name={che.title} onChangeText={(e) => handleChangeText(e.target.value, che.id)} onChangeFile={(e) => handleMeta(e.target.files[0], che.id)} valueText={answers[che.id] !== undefined ? answers[che.id].value : ""} valueImage={answers[che.id] !== undefined ? answers[che.id].image : ""} onDelete={() => handleDeleteImage(che.id, "image")} isCompleted={isCompleted} />

            {che.conditional === "yes" && che.condition === "name is" && answers[che.id]?.value == che.conditionValue && che?.conditionalList.map(
                (v) => {
                  return (
                    <CheckContainer
                      che={v}
                      answers={answers}
                      handleChangeText={handleChangeText}
                      handleFile={handleFile}
                      handleChangeCustom={handleChangeCustom}
                      handleMeta={handleMeta}
                      isConditional={true}
                      handleCondText={handleCondText}
                      getInspectionScore={getInspectionScore}
                      isCompleted={isCompleted}
                    />
                  );
                }
              )}
            {che.conditional === "yes" && che.condition === "name is not" && answers[che.id]?.value != che.conditionValue && che?.conditionalList.map(
                (v) => {
                  return (
                    <CheckContainer
                      che={v}
                      answers={answers}
                      handleChangeText={handleChangeText}
                      handleFile={handleFile}
                      handleChangeCustom={handleChangeCustom}
                      handleMeta={handleMeta}
                      isConditional={true}
                      handleCondText={handleCondText}
                      getInspectionScore={getInspectionScore}
                      isCompleted={isCompleted}
                    />
                  );
                }
              )}
            {che.conditional === "yes" && che.condition === "exists" && (answers[che.id]?.value && answers[che.id]?.image) && che?.conditionalList.map(
                (v) => {
                  return (
                    <CheckContainer
                      che={v}
                      answers={answers}
                      handleChangeText={handleChangeText}
                      handleFile={handleFile}
                      handleChangeCustom={handleChangeCustom}
                      handleMeta={handleMeta}
                      isConditional={true}
                      handleCondText={handleCondText}
                      getInspectionScore={getInspectionScore}
                      isCompleted={isCompleted}
                    />
                  );
                }
              )}
            {che.conditional === "yes" && che.condition === "does not exist" && (answers[che.id]?.value === "" && !answers[che.id]?.image) && che?.conditionalList.map(
                (v) => {
                  return (
                    <CheckContainer
                      che={v}
                      answers={answers}
                      handleChangeText={handleChangeText}
                      handleFile={handleFile}
                      handleChangeCustom={handleChangeCustom}
                      handleMeta={handleMeta}
                      isConditional={true}
                      handleCondText={handleCondText}
                      getInspectionScore={getInspectionScore}
                      isCompleted={isCompleted}
                    />
                  );
                }
              )}

               {che.is_subquestion === "yes" && che?.subQuestionList.map(
                (v) => {
                  return (
                    <CheckContainer
                      che={v}
                      answers={answers}
                      handleChangeText={handleChangeText}
                      handleFile={handleFile}
                      handleChangeCustom={handleChangeCustom}
                      handleMeta={handleMeta}
                      isConditional={true}
                      handleCondText={handleCondText}
                      getInspectionScore={getInspectionScore}
                      isCompleted={isCompleted}
                    />
                  );
                }
              )}
          </>}

        {(che.dataType === "Custom" || che.dataType === "Global") && <>
            <CustomField customFields={answers[che.id] !== undefined ? answers[che.id].responseLibrary : { responses: [] }} value={answers[che.id] !== undefined ? answers[che.id].value : []} // name={che.title}
              onChange={(e) => handleChangeCustom(e, che.id, che.multiselection)} isMultiple={che.multiselection} />

            {che.conditional === "yes" && che.condition === "is" && _.find(
                answers[che.id]?.value,
                { title: che.conditionValue }
              ) && che?.conditionalList.map((v) => {
                return <CheckContainer che={v} answers={answers} handleChangeText={handleChangeText} handleFile={handleFile} handleChangeCustom={handleChangeCustom} handleMeta={handleMeta} isConditional={true} handleCondText={handleCondText} getInspectionScore={getInspectionScore} isCompleted={isCompleted} />;
              })}
               {che.is_subquestion === "yes" && che?.subQuestionList.map(
                (v) => {
                  return (
                    <CheckContainer
                      che={v}
                      answers={answers}
                      handleChangeText={handleChangeText}
                      handleFile={handleFile}
                      handleChangeCustom={handleChangeCustom}
                      handleMeta={handleMeta}
                      isConditional={true}
                      handleCondText={handleCondText}
                      getInspectionScore={getInspectionScore}
                      isCompleted={isCompleted}
                    />
                  );
                }
              )}
          </>}
      </Grid>



      {isConditional === false && <Grid item xs={1} />}

      <Grid item xs={12}>
        {isConditional === false && <>
            <Grid container spacing={1} direction="row" style={{padding:'0 10px'}}>
              {actionList.length !== 0 && 
              <Grid item xs={12}>
                  <Paper variant="outlined" style={{ padding: 5, marginLeft: 7,
                      backgroundColor: Colors.backgroundColor }}>
                    <Typography variant="h6" style={{ marginLeft: 5 }}>
                      {" "}
                      {t("Actions")}
                    </Typography>
                    {actionList.map((v) => {
                      return <Grid item xs={12} key={v.id} style={{ margin: 5 }}>
                          {isCompleted == true ? <Paper variant="outlined" style={{ padding: 10, opacity: 0.5 }}>
                          {v.title}
                              &emsp;
                              {"(" + v.description + ")"}
                            </Paper> : <Paper variant="outlined" style={{ padding: 10 }} className="pointer-cursor" onClick={() => setAction(v)}>
                            {v.title}
                              &emsp;
                              {"(" + v.description + ")"}
                            </Paper>}
                        </Grid>;
                    })}
                  </Paper>
                </Grid>}

              {isEditor == false && (che.dataType === "Custom" || che.dataType === "Global") && <>
                  <Grid item>
                    {isCompleted == true ? <Button size="small" startIcon={<img src={noteIconG} width={15} />} disabled>
                        {t("Note")}
                      </Button> : <Button size="small" startIcon={<img src={noteIcon} width={15} />} onClick={() => {
                          note !== null && note !== undefined ? handleMeta(null, che.id, "note") : handleMeta("", che.id, "note");
                          note !== null && note !== undefined ? setNote(null) : setNote("");
                        }}>
                        {t("Note")}
                      </Button>}
                  </Grid>

                  <Grid item>
                    {/* {!answers[che.id].ismultiple ? ( */}
                    {isCompleted == true ? <Button size="small" startIcon={<img src={cameraIconG} width={15} />} disabled component="label">
                        {t("Photos")}
                      </Button> : <Button size="small" startIcon={<img src={cameraIcon} width={15} />} component="label">
                        {t("Photos")}
                        <input multiple type="file" accept="image/*" style={{ display: "none" }} onChange={(e) => handleMeta(e.target.files, che.id, "multple-images")} />
                      </Button>}
                    {/* ):(
                        <div>Khurram Naushad Khan</div>
                      )
                    } */}
                  </Grid>
                </>}


              {(package_id === "09b7b809-3f45-4439-9836-ba91b160174d" || package_id === "85232b2e-3301-4a8e-bd6e-d1f00c7dd1b5") && <Grid item>
                  {answers[che.id]?.video !== "" && (answers[che.id]?.video !== null && answers[che.id]?.video !== undefined) ? <>
                      {isCompleted == true ? <Button size="small" startIcon={<DeleteIcon />} disabled component="label" style={{ color: "#dadada" }}>
                          {t("Delete Video")}
                        </Button> : <Button size="small" startIcon={<DeleteIcon />} component="label" style={{ color: "red" }} onClick={() => handleDeleteVideo("", che.id)}>
                          {t("Delete Video")}
                        </Button>}
                    </> : <>
                      {isCompleted == true ? <Button size="small" startIcon={<img src={videoIconG} width={15} />} component="label" disabled>
                          {t("Video")}
                        </Button> : <Button size="small" startIcon={<img src={videoIcon} width={15} />} component="label">
                          {t("Video")}
                          <input type="file" accept="video/*" style={{ display: "none" }} onChange={(e) => handleMeta(e.target.files[0], che.id, "video")} />
                        </Button>}
                    </>}
                </Grid>}


              {isEditor == false && 
              <Grid item>
                  {isCompleted == true ? <Button size="small" startIcon={<img src={actionIconG} width={15} />} disabled>
                      {t("Action")}
                    </Button> : <Button size="small" startIcon={<img src={actionIcon} width={15} />} onClick={() => setActionField(!actionField)}>
                      {t("Action")}
                    </Button>}

                 
                  <InspectionAction toggleAction={toggleAction} state={action} handleDelete={handleDelete} />
                </Grid>}
            </Grid>
           
            {actionField === true && <Grid container style={{  width: "100%",padding:"10px" }}spacing={2}>
                        <Grid item xs={12} sm={6}>
                          <TextInputFeild value={actionFieldInput} name={"Action"} onChange={(e) => setActionFieldInput(e.target.value)} />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextInputFeild value={actionFieldDescription} name={"Description"} onChange={(e) => setActionFieldDescription(e.target.value)} />
                        </Grid>
                     
                        <Grid item xs={12} sm={6} >
                      <Button size="small" color="primary" variant="contained" className="addBtn" disableElevation style={{ margin: 5, padding: "2px", backgroundColor: Colors.globalColor8 }} onClick={createAction}>
                        {t("Create")}
                      </Button>
                      <Button size="small" variant="outlined" className="cancelBtn" style={{ margin: 5 }} onClick={() => setActionField(!actionField)}>
                        {t("Cancel")}
                      </Button>
                    </Grid>
                     </Grid>}


            <Grid container spacing={1}>
              {note !== null && note !== undefined && <Grid item xs={6}>
                  <TextInputFeild value={answers[che.id] !== undefined ? answers[che.id].note : ""} name={t("Note")} onChange={(e) => handleMeta(e.target.value, che.id, "note")} multiline={true} />
                </Grid>}

              {/* {(che.dataType === "Custom" || che.dataType === "Global") &&
                answers[che.id] !== undefined &&
                answers[che.id].image !== undefined &&
                answers[che.id].image !== null && (
                  <Grid item xs={6}>
                    <ModalImage
                      hideDownload
                      hideZoom
                      alt=""
                      small={
                        !answers[che.id].image.name
                          ? Colors.fileUrl + answers[che.id].image
                          : URL.createObjectURL(answers[che.id].image)
                      }
                      large={
                        !answers[che.id].image.name
                          ? Colors.fileUrl + answers[che.id].image
                          : URL.createObjectURL(answers[che.id].image)
                      }
                      width="100px"
                    />
                  </Grid>
                )} */}
              {(che.dataType === "Custom" || che.dataType === "Global") && answers[che.id] !== undefined && answers[che.id].ismultiple && <Grid item xs={12}>
                  <div style={{ flexDirection: "row", display: "flex", overflow: "auto" }}>
                    {answers[che.id].imageslist.map((img, index) => {
                      return <div>
                          <div style={{ height: "80%" }}>
                            <ModalImage hideDownload hideZoom alt="" className="thumbnailInspectionImage" small={img.status == "saved" ? img.Url : URL.createObjectURL(img.image)
                                //URL.createObjectURL(img.image)
                                // !answers[che.id].image.name
                                //   ? Colors.fileUrl + answers[che.id].image
                                //   : URL.createObjectURL(answers[che.id].image)
                              } large={img.status == "saved" ? img.Url : URL.createObjectURL(img.image)
                                //URL.createObjectURL(img.image)
                                //   !answers[che.id].image.name
                                //     ? Colors.fileUrl + answers[che.id].image
                                //     : URL.createObjectURL(answers[che.id].image)
                              } />
                          </div>
                          <div>
                            {isCompleted == true ? (
                              <Button
                                size="small"
                                startIcon={<DeleteIcon />}
                                component="label"
                                style={{ color: "#dadada" }}
                                disabled
                              />
                            ) : (
                              <Button
                                size="small"
                                startIcon={<DeleteIcon />}
                                component="label"
                                style={{ color: "red" }}
                                onClick={() =>
                                  handleDeleteMultipleImage(che.id, index)
                                }
                              />
                            )}
                          </div>
                        </div>;
                    })}
                  </div>

                  {/* <ModalImage
                      hideDownload
                      hideZoom
                      alt=""
                      small={
                        URL.createObjectURL(answers[che.id].imageslist[0])
                        // !answers[che.id].image.name
                        //   ? Colors.fileUrl + answers[che.id].image
                        //   : URL.createObjectURL(answers[che.id].image)
                      }
                      // large={
                      //   !answers[che.id].image.name
                      //     ? Colors.fileUrl + answers[che.id].image
                      //     : URL.createObjectURL(answers[che.id].image)
                      // }
                      width="100px"
                    /> */}
                </Grid>}
              {/* {answers[che.id]?.video !== undefined &&
                answers[che.id]?.video !== null && (
                  <Grid item xs={6}>
                    <video width="320" height="240" autoplay controls>
                      <source
                        src={
                          answers[che.id]?.videoEdited == true
                            ? URL.createObjectURL(answers[che.id]?.video)
                            : Colors.fileUrl.replace(
                                "view",
                                browser_name != "safari"
                                  ? "view_video"
                                  : "view_video_stream"
                              ) + answers[che.id]?.video
                        }
                        type="video/mp4"
                      />
                      Your browser does not support the video tag.
                    </video>
                  </Grid>
                )} */}

              {answers[che.id]?.video !== undefined && answers[che.id]?.video !== null && <Grid item xs={6}>
                  {/* {answers[che.id]?.video_key && answers[che.id]?.video_key} */}
                  <video width="320" height="240" autoplay controls>
                    <source src={answers[che.id]?.videoEdited == true ? URL.createObjectURL(answers[che.id]?.video) : answers[che.id]?.video} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                </Grid>}
            </Grid>
          </>}
      </Grid>
      <Grid item xs={1} />
    </Grid>;
}

